import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Image, Card, Form, Badge, Accordion, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPhoneAlt, FaEye, FaRegHeart, FaShareAlt, FaRegPaperPlane , FaVideo} from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { HiOutlineBellAlert } from "react-icons/hi2";
import Navbar from "../../Pages/Navbar/EmployerNavbar";
import { useNavigate, useLocation } from 'react-router-dom';
import BaseUrl from '../../ApiServices/BaseUrl';
import EmployerNavbar from '../../Pages/Navbar/EmployerNavbar';
import Footer from "../../Footer/Footer"
import moment from 'moment';
import Swal from 'sweetalert2';
import ReportCandidate from './ReportCandidate';
import defaultProfileImage from '../../Pages/Images/defaultimage.webp'; //
import './Candidates.css';
import '../Nurse/Candidates.css';
import { getVisibleOfferBadgeText, getVisibleSourceLabel, hasHighlightedSourceLabel, hasVisibleOfferBadge } from '../../../utils/candidateBadges';
import CandidateCardHeading from '../../Common/CandidateCardHeading';
import SendAlertScrollPrompt from '../../Common/SendAlertPrompt/SendAlertScrollPrompt';

function Candidates() {
    const PAGE_SIZE = 15;
    const [candidates, setCandidates] = useState([]);
    const [filteredCandidates, setFilteredCandidates] = useState([]);
    const [jobs, setJobs] = useState([]); // New state for employer jobs
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState(null);
    const [activeFilter] = useState('all');
    const [appliedUserIds, setAppliedUserIds] = useState([]); // Store applied user IDs
    const navigate = useNavigate();
    const [showMoreJobPosition, setShowMoreJobPosition] = useState(false);
    const [showMoreJobType, setShowMoreJobType] = useState(false);
    const [showMoreLanguage, setShowMoreLanguage] = useState(false);
    const [showMoreMainSkills, setShowMoreMainSkills] = useState(false);
    const [messages, setMessages] = useState([]);
    const [showMessageModal, setShowMessageModal] = useState(false);
    // const [messageContent, setMessageContent] = useState("I'm interested");
    const [messageContent, setMessageContent] = useState("Hello,I am interested in your profile. Please let me know if you are interested in working with me.");
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
    const [selectedCandidateForReport, setSelectedCandidateForReport] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareContent, setShareContent] = useState('');
    const [shareUrl, setShareUrl] = useState('');
    const [showLocation, setShowLocation] = useState(false);
    const [showContractStatus, setShowContractStatus] = useState(false);
    const [showPostedBy, setShowPostedBy] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);
    const [shortlistedCandidates, setShortlistedCandidates] = useState({});
    const [unlockedIds, setUnlockedIds] = useState([]);
    const [dailyCallCount, setDailyCallCount] = useState(0);
    const [dailyWhatsAppCount, setDailyWhatsAppCount] = useState(0);
    const [dailyMessageCount, setDailyMessageCount] = useState(0); // New state for message count
    const [lastResetDate, setLastResetDate] = useState('');
    const [freeTrialStartDate, setFreeTrialStartDate] = useState(''); // New state for free trial
    // Mobile responsive states
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [hasPostedJob, setHasPostedJob] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const autoSearchTimeoutRef = useRef(null);
    const isAutoSearchingRef = useRef(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [visibleCount, setVisibleCount] = useState(9);
    // const candidateName = selectedCandidate?.first_name?.split('@')[0] || 'Candidate';
    // const personalizedMessage = `Hello ${candidateName}, I am interested in your profile. Please let me know if you are interested in working with me.`;

    const user = JSON.parse(localStorage.getItem("user")) || {};
    const location = useLocation();
    const categoryFilter = new URLSearchParams(location.search).get('category');
    const employerId = user.id || '';
    const planName = user.plan_name || '';
    const planStartDate = user.plan_startdate || '';
    const planEndDate = user.plan_enddate || '';

    const getCandidateKey = (candidate) =>
        candidate?.id || candidate?.user_id || candidate?.job_seeker_id || `${candidate?.email || ''}-${candidate?.phone_number || ''}`;

    const mergeUniqueCandidates = (existingCandidates, incomingCandidates) => {
        const uniqueCandidates = new Map();

        [...existingCandidates, ...incomingCandidates].forEach(candidate => {
            const candidateKey = getCandidateKey(candidate);
            if (!uniqueCandidates.has(candidateKey)) {
                uniqueCandidates.set(candidateKey, candidate);
            }
        });

        return Array.from(uniqueCandidates.values());
    };

    // Filter states
    const [jobPosition, setJobPosition] = useState({
        maid: false, driver: false, cook: false, nanny: false, nurse: false, houseboy: false,
        tailor: false, teacher: false, trainer: false, gardener: false, butler: false, housekeeper: false,
        laundryWorker: false, personalAssistant: false, caregiver: false, elderCareCompanion: false,
        petSitter: false, houseManager: false, cleaner: false, maintenanceWorker: false,
        babySitter: false, tutor: false, chauffeur: false, housemaid: false, kitchenStaff: false,
        diningRoomAttendant: false, personalChef: false, eventCoordinator: false,
        householdAdministrator: false, domesticAssistant: false
    });

    const [candidateLocation, setCandidateLocation] = useState({
        india: false,
        bangladesh: false,
        nepal: false,
        sriLanka: false,
        pakistan: false,
        philippines: false,
        indonesia: false,
        myanmar: false,
        vietnam: false,
        cambodia: false,
        thailand: false,
        ethiopia: false,
        kenya: false,
        uganda: false,
        tanzania: false,
        rwanda: false,
        ghana: false,
        nigeria: false,
        sierraLeone: false,
        burundi: false
    });

    const [jobCountry, setJobCountry] = useState({
        qatar: false,
        uae: false,
        saudiArabia: false,
        kuwait: false,
        bahrain: false,
        oman: false,
        usa: false,
        canada: false,
        uk: false,
        australia: false,
        germany: false,
        france: false,
        italy: false,
        spain: false,
        netherlands: false,
        belgium: false,
        switzerland: false,
        sweden: false,
        norway: false,
        denmark: false,
        finland: false,
        japan: false,
        southKorea: false,
        singapore: false,
        malaysia: false,
        china: false,
        hongKong: false,
        newZealand: false,
        southAfrica: false,
        brazil: false,
        mexico: false,
        argentina: false,
        chile: false,
        colombia: false,
        peru: false,
        egypt: false,
        morocco: false,
        algeria: false,
        tunisia: false,
        jordan: false,
        lebanon: false,
        iraq: false,
        iran: false,
        turkey: false,
        cyprus: false,
        malta: false,
        greece: false,
        portugal: false,
        austria: false,
        hungary: false,
        poland: false,
        czechRepublic: false,
        slovakia: false,
        slovenia: false,
        croatia: false,
        romania: false,
        bulgaria: false,
        serbia: false,
        montenegro: false,
        albania: false,
        northMacedonia: false,
        bosniaHerzegovina: false,
        kosovo: false,
        estonia: false,
        latvia: false,
        lithuania: false,
        belarus: false,
        ukraine: false,
        moldova: false,
        georgia: false,
        armenia: false,
        azerbaijan: false,
        kazakhstan: false,
        uzbekistan: false,
        turkmenistan: false,
        kyrgyzstan: false,
        tajikistan: false,
        afghanistan: false,
        pakistan: false,
        india: false,
        bangladesh: false,
        sriLanka: false,
        nepal: false,
        bhutan: false,
        myanmar: false,
        thailand: false,
        laos: false,
        cambodia: false,
        vietnam: false,
        indonesia: false,
        philippines: false,
        brunei: false,
        eastTimor: false,
        papuaNewGuinea: false,
        fiji: false,
        solomonIslands: false,
        vanuatu: false,
        samoa: false,
        tonga: false,
        marshallIslands: false,
        micronesia: false,
        palau: false,
        nauru: false,
        tuvalu: false,
        kiribati: false
    });
    const [showMoreJobCountry, setShowMoreJobCountry] = useState(false);

    const [jobType, setJobType] = useState({
        fullTime: false, partTime: false, liveIn: false, liveOut: false, temporary: false,
        permanent: false, internship: false, contractual: false, freelance: false,
        volunteer: false, fresher: false
    });

    const [contractStatus, setContractStatus] = useState({
        permanent: false, temporary: false, contract: false
    });

    const [postedBy, setPostedBy] = useState({
        agency: false, directEmployer: false
    });

    const [language, setLanguage] = useState({
        english: false, mandarin: false, arabic: false, hindi: false, tagalog: false,
        cantonese: false, malay: false, tamil: false
    });

    const [mainSkills, setMainSkills] = useState({
        childcare: false, elderlyCare: false, cooking: false, cleaning: false,
        laundry: false, ironing: false, petCare: false, gardening: false
    });

    const [startDate, setStartDate] = useState('');
    const [showMoreLocations, setShowMoreLocations] = useState(false);

    // Update screen width on resize
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = screenWidth < 768; // Mobile breakpoint

    const handleJobPositionChange = (e) => {
        const { name, checked } = e.target;
        setJobPosition(prev => ({ ...prev, [name]: checked }));
    };

    const handleJobCountryChange = (e) => {
        const { name, checked } = e.target;
        setJobCountry(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    // Fetch employer's jobs
    useEffect(() => {
        const fetchJobData = async () => {
            try {
                if (!employerId) return;

                const response = await fetch(`${BaseUrl}/api/employer/by-user?user_id=${employerId}`);
                if (!response.ok) throw new Error('Failed to fetch job data');

                let data = await response.json();
                if (!Array.isArray(data)) data = data ? [data] : [];

                // Robust date parser
                const parseDateValue = (val) => {
                    if (val == null) return null;

                    if (typeof val === 'number') {
                        // seconds -> ms, or already ms
                        return val < 1e12 ? val * 1000 : val;
                    }

                    if (typeof val === 'string') {
                        // /Date(123456789)/
                        const m = val.match(/\/Date\((\d+)(?:[+-]\d+)?\)\//);
                        if (m) return Number(m[1]);

                        const parsed = Date.parse(val);
                        if (!Number.isNaN(parsed)) return parsed;

                        const n = Number(val);
                        if (!Number.isNaN(n)) return parseDateValue(n);

                        return null;
                    }

                    if (typeof val === 'object') {
                        // Firestore-like Timestamp objects or objects with helper methods
                        if (typeof val.toDate === 'function') {
                            try { return val.toDate().getTime(); } catch (e) { }
                        }
                        if (typeof val.toMillis === 'function') {
                            try { return val.toMillis(); } catch (e) { }
                        }
                        if (typeof val.seconds === 'number') {
                            return val.seconds * 1000 + Math.floor((val.nanoseconds || 0) / 1e6);
                        }
                        if (typeof val._seconds === 'number') {
                            return val._seconds * 1000 + Math.floor((val._nanoseconds || 0) / 1e6);
                        }
                        if (val.$date) return parseDateValue(val.$date);
                        if (val.$numberLong) return parseDateValue(Number(val.$numberLong));
                        return null;
                    }

                    return null;
                };

                const getTimestampFromJob = (job) => {
                    const keysToTry = [
                        'created_at', 'createdAt', 'posted_at', 'postedAt',
                        'updated_at', 'updatedAt', 'timestamp', 'date', 'created', 'added_at', 'addedAt'
                    ];

                    for (const k of keysToTry) {
                        if (k in job) {
                            const t = parseDateValue(job[k]);
                            if (t !== null) return t;
                        }
                    }

                    // Try Mongo ObjectId timestamp from _id or id (first 8 hex chars -> seconds)
                    const maybeOid = job._id?.$oid || job._id || job.id;
                    if (maybeOid) {
                        if (typeof maybeOid === 'string' && /^[0-9a-fA-F]{24}$/.test(maybeOid)) {
                            try { return parseInt(maybeOid.substring(0, 8), 16) * 1000; } catch (e) { }
                        }
                        const parsed = parseDateValue(maybeOid);
                        if (parsed !== null) return parsed;
                    }

                    return null;
                };

                const parseArrayField = (field) => {
                    if (!field) return [];
                    if (Array.isArray(field)) return field;
                    if (typeof field === 'string') {
                        try {
                            const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                            return Array.isArray(parsed) ? parsed : [];
                        } catch {
                            return field.split(',').map(item => item.trim()).filter(item => item);
                        }
                    }
                    return [];
                };

                const processedData = data.map(job => ({
                    ...job,
                    preferred_candidates_country: parseArrayField(job.preferred_candidates_country),
                    candidates_country_experience: parseArrayField(job.candidates_country_experience),
                    main_skills: parseArrayField(job.main_skills).filter(skill => skill && !['[', ']', '"', '\\'].includes(skill)),
                    cooking_skills: parseArrayField(job.cooking_skills).filter(skill => skill && !['[', ']', '"', '\\'].includes(skill)),
                    other_skills: parseArrayField(job.other_skills).filter(skill => skill && !['[', ']', '"', '\\'].includes(skill)),
                    preferred_years_of_experience: parseArrayField(job.preferred_years_of_experience),
                    offer_for_selected_candidates: parseArrayField(job.offer_for_selected_candidates),
                    preferred_language_for_worker: parseArrayField(job.preferred_language_for_worker),
                    profile_photo_url: job.profile_photo ? `${BaseUrl}${job.profile_photo}` : null,
                    __ts: getTimestampFromJob(job)
                }));

                const hasAnyTs = processedData.some(j => j.__ts !== null && j.__ts !== undefined);

                if (hasAnyTs) {
                    // newest first
                    processedData.sort((a, b) => (b.__ts || 0) - (a.__ts || 0));
                } else {
                    // fallback: assume server returned newest-last -> reverse so newest is first
                    processedData.reverse();
                }

                const finalData = processedData.map(({ __ts, ...rest }) => rest);

                setJobs(finalData);
            } catch (err) {
                console.error('Error fetching jobs:', err);
            }
        };

        if (employerId) {
            fetchJobData();
        }
    }, [employerId]);

    useEffect(() => {
        const checkIfUserPostedJob = async () => {
            try {
                console.log('Checking if user has posted job...');
                console.log('Current employerId:', employerId);

                const response = await fetch(`${BaseUrl}/api/employer/all`);
                if (!response.ok) {
                    throw new Error('Failed to fetch employer jobs');
                }

                const allJobs = await response.json();
                console.log('All jobs from API:', allJobs);
                console.log('Total jobs from API:', allJobs.length);

                // Convert employerId to number for comparison
                const userId = parseInt(employerId);
                console.log('Parsed employerId for comparison:', userId);

                // Filter jobs for current user
                const userJobs = allJobs.filter(job => {
                    const jobUserId = parseInt(job.user_id);
                    console.log(`Job ID: ${job.id}, Job user_id: ${job.user_id}, Parsed: ${jobUserId}, Matches current user: ${jobUserId === userId}`);
                    return jobUserId === userId;
                });

                console.log('Filtered user jobs:', userJobs);
                console.log('Number of jobs posted by user:', userJobs.length);

                // Check if user has any jobs
                const hasJob = userJobs.length > 0;
                console.log('User has posted job?', hasJob);

                // Show detailed job information if available
                if (userJobs.length > 0) {
                    console.log('Job details:');
                    userJobs.forEach((job, index) => {
                        console.log(`Job ${index + 1}:`, {
                            id: job.id,
                            job_title: job.job_title,
                            status: job.status,
                            posted_on: job.posted_on
                        });
                    });
                } else {
                    console.log('User has NOT posted any jobs');
                }

                setHasPostedJob(hasJob);

            } catch (error) {
                console.error('Error checking user jobs:', error);
                console.log('Setting hasPostedJob to false due to error');
                setHasPostedJob(false);
            }
        };

        if (employerId) {
            checkIfUserPostedJob();
        } else {
            console.log('No employerId available, cannot check for jobs');
            setHasPostedJob(false);
        }
    }, [employerId]);
    // Fetch unlocked candidate IDs for this employer
    useEffect(() => {
        const fetchUnlockedIds = async () => {
            if (!employerId) return;
            try {
                const response = await fetch(`${BaseUrl}/api/employer/contact-unlock/unlocked-ids?employer_id=${employerId}`);
                if (response.ok) {
                    const data = await response.json();
                    setUnlockedIds(data.unlocked_ids || []);
                }
            } catch (err) {
                console.error('Error fetching unlocked IDs:', err);
            }
        };
        fetchUnlockedIds();
    }, [employerId]);

    // Initialize free trial and daily counts
    useEffect(() => {
        const initializeFreeTrialAndCounts = () => {
            const today = new Date().toDateString();
            const savedFreeTrialStartDate = localStorage.getItem('freeTrialStartDate');
            const savedLastResetDate = localStorage.getItem('lastResetDate');
            const savedCallCount = parseInt(localStorage.getItem('dailyCallCount') || '0');
            const savedWhatsAppCount = parseInt(localStorage.getItem('dailyWhatsAppCount') || '0');
            const savedMessageCount = parseInt(localStorage.getItem('dailyMessageCount') || '0');

            // Initialize free trial if user is on free plan and trial not started
            if ((!planName || planName.toLowerCase() === 'free') && !savedFreeTrialStartDate) {
                const trialStartDate = new Date().toDateString();
                localStorage.setItem('freeTrialStartDate', trialStartDate);
                setFreeTrialStartDate(trialStartDate);
            } else {
                setFreeTrialStartDate(savedFreeTrialStartDate);
            }

            // Reset daily counts if it's a new day
            if (savedLastResetDate !== today) {
                setDailyCallCount(0);
                setDailyWhatsAppCount(0);
                setDailyMessageCount(0);
                setLastResetDate(today);

                localStorage.setItem('lastResetDate', today);
                localStorage.setItem('dailyCallCount', '0');
                localStorage.setItem('dailyWhatsAppCount', '0');
                localStorage.setItem('dailyMessageCount', '0');
            } else {
                setDailyCallCount(savedCallCount);
                setDailyWhatsAppCount(savedWhatsAppCount);
                setDailyMessageCount(savedMessageCount);
                setLastResetDate(savedLastResetDate);
            }
        };

        initializeFreeTrialAndCounts();

        // Check every minute if date has changed
        const interval = setInterval(() => {
            const today = new Date().toDateString();
            if (lastResetDate !== today) {
                setDailyCallCount(0);
                setDailyWhatsAppCount(0);
                setDailyMessageCount(0);
                setLastResetDate(today);

                localStorage.setItem('lastResetDate', today);
                localStorage.setItem('dailyCallCount', '0');
                localStorage.setItem('dailyWhatsAppCount', '0');
                localStorage.setItem('dailyMessageCount', '0');
            }
        }, 60000);

        return () => clearInterval(interval);
    }, [lastResetDate, planName]);

    // Check if user is in free trial period
    const isInFreeTrial = () => {
        // Gold and Silver users have all access
        if (planName && (planName.toLowerCase().includes('gold') || planName.toLowerCase().includes('silver'))) {
            return true;
        }

        // Free users get 7-day trial
        if (!freeTrialStartDate) return false;

        const trialStart = new Date(freeTrialStartDate);
        const today = new Date();
        const daysSinceTrialStart = Math.floor((today - trialStart) / (1000 * 60 * 60 * 24));

        return daysSinceTrialStart < 7; // 7-day free trial
    };

    // Check if user can use call feature
    const canUseCall = () => {
        // Gold users have unlimited calls
        if (planName && planName.toLowerCase().includes('gold')) {
            return true;
        }

        // Silver users have 10 calls per day
        if (planName && planName.toLowerCase().includes('silver')) {
            return dailyCallCount < 10;
        }

        // Free trial users (first 7 days) have 2 calls per day
        if (isInFreeTrial()) {
            return dailyCallCount < 2;
        }

        // Regular free users after trial: no calls
        return false;
    };

    // Check if user can use WhatsApp
    const canUseWhatsApp = () => {
        // Gold users have unlimited WhatsApp
        if (planName && planName.toLowerCase().includes('gold')) {
            return true;
        }

        // Silver users have 10 WhatsApp per day
        if (planName && planName.toLowerCase().includes('silver')) {
            return dailyWhatsAppCount < 10;
        }

        // Free trial users (first 7 days) have 2 WhatsApp per day
        if (isInFreeTrial()) {
            return dailyWhatsAppCount < 2;
        }

        // Regular free users after trial: no WhatsApp
        return false;
    };

    // Message permission now comes from backend feature checks (new subscription model).
    const canSendMessage = () => true;

    // Check if user can use share feature
    const canUseShare = () => {
        // Gold and Silver users have share feature
        if (planName && (planName.toLowerCase().includes('gold') || planName.toLowerCase().includes('silver'))) {
            return true;
        }

        // Free trial users (first 7 days) have share feature
        if (isInFreeTrial()) {
            return true;
        }

        // Regular free users after trial: no share
        return false;
    };

    // Check if user can use shortlist feature
    const canUseShortlist = () => {
        // Gold and Silver users have shortlist feature
        if (planName && (planName.toLowerCase().includes('gold') || planName.toLowerCase().includes('silver'))) {
            return true;
        }

        // Free trial users (first 7 days) have shortlist feature
        if (isInFreeTrial()) {
            return true;
        }

        // Regular free users after trial: no shortlist
        return false;
    };

    // Get call limit information
    const getCallLimitInfo = () => {
        if (planName && planName.toLowerCase().includes('gold')) {
            return { canUse: true, message: 'Unlimited calls' };
        }

        if (planName && planName.toLowerCase().includes('silver')) {
            const remaining = 10 - dailyCallCount;
            const canUse = remaining > 0;
            return {
                canUse: canUse,
                message: canUse
                    ? `Silver plan: ${remaining}/10 calls today`
                    : 'Your daily call quota (10 calls) is done. Please wait for tomorrow or upgrade to Gold plan for unlimited calls.'
            };
        }

        if (isInFreeTrial()) {
            const remaining = 2 - dailyCallCount;
            const daysUsed = Math.floor((new Date() - new Date(freeTrialStartDate)) / (1000 * 60 * 60 * 24)) + 1;
            const daysLeft = 7 - daysUsed;
            return {
                canUse: remaining > 0,
                message: `Free trial: ${remaining}/2 calls today (${daysLeft} days left)`
            };
        }

        // FIXED: For free plan users, return a proper upgrade message
        return {
            canUse: false,
            message: 'Call feature not available for free plan',
            upgradeMessage: 'Upgrade to Gold Subscription to contact candidates directly and close positions faster.'
        };
    };

    // Get WhatsApp limit information
    const getWhatsAppLimitInfo = () => {
        if (planName && planName.toLowerCase().includes('gold')) {
            return { canUse: true, message: 'Unlimited WhatsApp' };
        }

        if (planName && planName.toLowerCase().includes('silver')) {
            const remaining = 10 - dailyWhatsAppCount;
            const canUse = remaining > 0;
            return {
                canUse: canUse,
                message: canUse
                    ? `Silver plan: ${remaining}/10 WhatsApp today`
                    : 'Your daily WhatsApp quota (10 messages) is done. Please wait for tomorrow or upgrade to Gold plan for unlimited WhatsApp.'
            };
        }

        if (isInFreeTrial()) {
            const remaining = 2 - dailyWhatsAppCount;
            const daysUsed = Math.floor((new Date() - new Date(freeTrialStartDate)) / (1000 * 60 * 60 * 24)) + 1;
            const daysLeft = 7 - daysUsed;
            return {
                canUse: remaining > 0,
                message: `Free trial: ${remaining}/2 WhatsApp today (${daysLeft} days left)`
            };
        }

        // FIXED: For free plan users, return a proper upgrade message
        return {
            canUse: false,
            message: 'WhatsApp feature not available for free plan',
            upgradeMessage: 'Upgrade to Gold Subscription to contact candidates directly and close positions faster.'
        };
    };

    // Legacy local daily-message quota is removed. Access is validated via backend feature checks.
    const getMessageLimitInfo = () => ({
        canSend: true,
        message: 'Message access is controlled by your active subscription feature.',
        upgradeRequired: false
    });

    // Get share limit information
    const getShareLimitInfo = () => {
        if (planName && (planName.toLowerCase().includes('gold') || planName.toLowerCase().includes('silver'))) {
            return { canUse: true, message: 'Share available' };
        }

        if (isInFreeTrial()) {
            const daysUsed = Math.floor((new Date() - new Date(freeTrialStartDate)) / (1000 * 60 * 60 * 24)) + 1;
            const daysLeft = 7 - daysUsed;
            return {
                canUse: true,
                message: `Free trial: Share available (${daysLeft} days left)`
            };
        }

        return {
            canUse: false,
            message: 'Share feature not available for free plan'
        };
    };

    // Get shortlist limit information
    const getShortlistLimitInfo = () => {
        if (planName && (planName.toLowerCase().includes('gold') || planName.toLowerCase().includes('silver'))) {
            return { canUse: true, message: 'Shortlist available' };
        }

        if (isInFreeTrial()) {
            const daysUsed = Math.floor((new Date() - new Date(freeTrialStartDate)) / (1000 * 60 * 60 * 24)) + 1;
            const daysLeft = 7 - daysUsed;
            return {
                canUse: true,
                message: `Free trial: Shortlist available (${daysLeft} days left)`
            };
        }

        return {
            canUse: false,
            message: 'Shortlist feature not available for free plan'
        };
    };

    // ─── Contact unlock helper: open call ───
    const openCall = async (candidate) => {
        let phoneNumber = '';
        if (candidate.agency_uid) {
            try {
                const response = await fetch(`${BaseUrl}/api/agency/${candidate.agency_uid}`);
                if (response.ok) {
                    const agencyData = await response.json();
                    phoneNumber = agencyData?.official_phone || candidate.whatsapp_number || '9820867896';
                } else { phoneNumber = candidate.whatsapp_number || '9820867896'; }
            } catch { phoneNumber = candidate.whatsapp_number || '9820867896'; }
        } else { phoneNumber = candidate.whatsapp_number || '9820867896'; }

        const cleanNumber = phoneNumber.toString().replace(/[^\d+]/g, '');
        let finalNumber = cleanNumber;
        if (!cleanNumber.startsWith('+')) {
            if (cleanNumber.startsWith('91') && cleanNumber.length >= 12) finalNumber = '+' + cleanNumber;
            else if (cleanNumber.startsWith('63') && cleanNumber.length >= 12) finalNumber = '+' + cleanNumber;
            else if (cleanNumber.length === 10) finalNumber = '+91' + cleanNumber;
            else { finalNumber = '+919820867896'; }
        }
        window.location.href = `tel:${finalNumber}`;
    };

    // ─── Contact unlock helper: open WhatsApp ───
    const openWhatsApp = async (candidate) => {
        let whatsappNumber = '';
        if (candidate.agency_uid) {
            try {
                const response = await fetch(`${BaseUrl}/api/agency/${candidate.agency_uid}`);
                if (response.ok) {
                    const agencyData = await response.json();
                    whatsappNumber = agencyData?.official_phone || candidate.whatsapp_number || '9820867896';
                } else { whatsappNumber = candidate.whatsapp_number || '9820867896'; }
            } catch { whatsappNumber = candidate.whatsapp_number || '9820867896'; }
        } else { whatsappNumber = candidate.whatsapp_number || '9820867896'; }

        const cleanNumber = whatsappNumber.toString().replace(/\D/g, '');
        let finalNumber = cleanNumber;
        if (cleanNumber.startsWith('91') && cleanNumber.length >= 12) finalNumber = cleanNumber;
        else if (cleanNumber.length === 10) finalNumber = '91' + cleanNumber;
        else if (cleanNumber.length < 10) finalNumber = '919820867896';

        const jobPosition = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ') : (candidate.job_position || 'candidate');
        const message = `Hi, I'm interested in your ${jobPosition} profile from Gulf Worker website`;
        window.open(`https://wa.me/${finalNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    // ─── Subscription-based contact unlock (shared logic) ───
    const performContactUnlock = async (candidate, actionFn, actionLabel) => {
        if (!employerId) {
            Swal.fire({ icon: 'warning', title: 'Login Required', text: 'Please login to contact candidates' });
            return;
        }

        if (!hasPostedJob) {
            Swal.fire({
                icon: 'warning', title: '',
                html: `<div style="text-align: center;"><p style="font-weight: bold; margin-bottom: 5px;">To view this candidate's profile,</p><p style="font-weight: bold;">please post your job here first.</p><div class="mt-3"><button id="post-job-btn" class="btn btn-success btn-sm me-2" style="border-radius: 5px; height:32px;">Post a Job</button><button id="cancel-btn" class="btn btn-outline-secondary btn-sm" style="border-radius: 5px; height:32px;">Cancel</button></div></div>`,
                showConfirmButton: false, showCloseButton: true,
                didOpen: () => {
                    document.getElementById('post-job-btn').onclick = () => { Swal.close(); setTimeout(() => window.location.href = '/basicinfo', 300); };
                    document.getElementById('cancel-btn').onclick = () => Swal.close();
                }
            });
            return;
        }

        try {
            // 1. Check if already unlocked
            const checkRes = await fetch(`${BaseUrl}/api/employer/contact-unlock/check?employer_id=${employerId}&candidate_user_id=${candidate.user_id}`);
            const checkData = await checkRes.json();
            if (checkData.unlocked) {
                actionFn(candidate);
                return;
            }

            // 2. Check subscription feature
            const featureRes = await fetch(`${BaseUrl}/api/employer/check-feature?employerId=${employerId}&feature=employer_contact_unlock`);
            const featureData = await featureRes.json();

            if (!featureData.allowed) {
                if (featureData.reason === 'no_subscription') {
                    Swal.fire({
                        icon: 'warning', title: 'No Subscription',
                        text: 'You need an active subscription to view candidate contact details.',
                        confirmButtonText: 'View Plans', showCancelButton: true
                    }).then(r => { if (r.isConfirmed) navigate('/subscriptionplans'); });
                } else if (featureData.reason === 'limit_reached') {
                    Swal.fire({ icon: 'error', title: 'Limit Reached', text: `You have used all ${featureData.limit} contact unlocks for your plan.` });
                } else if (featureData.reason === 'insufficient_wallet') {
                    Swal.fire({
                        icon: 'error', title: 'Insufficient Balance',
                        text: `Your wallet balance (${featureData.balance}) is less than the unlock cost (${featureData.required}). Please top up.`,
                        confirmButtonText: 'Top Up', showCancelButton: true
                    }).then(r => { if (r.isConfirmed) navigate('/subscriptionplans'); });
                } else {
                    Swal.fire({ icon: 'warning', title: 'Subscription Required', text: 'Please subscribe to a plan to contact candidates.' });
                }
                return;
            }

            // 3. For PPC, show confirmation with cost
            if (featureData.plan_type === 'pay_per_click') {
                const result = await Swal.fire({
                    title: 'Unlock Contact Details?',
                    html: `
                        <div style="text-align: left; background: #fff; border-radius: 12px; padding: 5px; font-family: 'Inter', sans-serif;">
                            <div style="background: #f8f9fa; border-radius: 10px; padding: 15px; border: 1px solid #e9ecef;">
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                    <div style="display: flex; align-items: center; color: #495057;"><span style="margin-right: 8px;">💰</span><span style="font-weight: 500;">Unlock Cost</span></div>
                                    <span style="font-weight: 700; color: #212529; font-size: 1.1rem;">${featureData.price_per_unit} <span style="font-size: 0.8em; font-weight: 400; color: #6c757d;">Units</span></span>
                                </div>
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                    <div style="display: flex; align-items: center; color: #495057;"><span style="margin-right: 8px;">🕒</span><span style="font-weight: 500;">Access Duration</span></div>
                                    <span style="font-weight: 600; color: #212529;">12 Hours</span>
                                </div>
                                <div style="margin-top: 15px; padding-top: 12px; border-top: 2px dashed #dee2e6; display: flex; justify-content: space-between; align-items: center;">
                                    <div style="display: flex; align-items: center; color: #495057;"><span style="margin-right: 8px;">💳</span><span style="font-weight: 500;">Wallet Balance</span></div>
                                    <span style="font-weight: 700; color: #28a745;">${featureData.wallet_balance}</span>
                                </div>
                            </div>
                            <p style="margin-top: 15px; color: #868e96; font-size: 0.85rem; line-height: 1.4; text-align: center;">Confirming will deduct the units and reveal contact details instantly.</p>
                        </div>
                    `,
                    confirmButtonText: `Unlock & ${actionLabel}`,
                    showCancelButton: true, confirmButtonColor: '#28a745', cancelButtonColor: '#6c757d', reverseButtons: true,
                    didOpen: () => {
                        const confirmBtn = Swal.getConfirmButton(); const cancelBtn = Swal.getCancelButton();
                        confirmBtn.style.width = '160px'; cancelBtn.style.width = '160px';
                        confirmBtn.style.padding = '12px 0'; cancelBtn.style.padding = '12px 0';
                    }
                });
                if (!result.isConfirmed) return;
            }

            // 4. Perform unlock
            const unlockRes = await fetch(`${BaseUrl}/api/employer/contact-unlock`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ employer_id: employerId, candidate_user_id: candidate.user_id })
            });
            const unlockData = await unlockRes.json();

            if (unlockData.unlocked || unlockData.already_unlocked) {
                setUnlockedIds(prev => [...new Set([...prev, candidate.user_id])]);
                actionFn(candidate);
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: unlockData.error || 'Failed to unlock contact.' });
            }
        } catch (err) {
            console.error('Contact unlock error:', err);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong. Please try again.' });
        }
    };

    const handleCallClick = async (candidate) => {
        await performContactUnlock(candidate, openCall, 'Call');
    };

    const handleWhatsAppClick = async (candidate) => {
        await performContactUnlock(candidate, openWhatsApp, 'View');
    };

    const checkEmployerMessageFeature = async () => {
        if (!employerId) {
            Swal.fire({
                icon: 'warning',
                title: 'Login Required',
                text: 'Please login to message candidates.'
            });
            return false;
        }

        try {
            const featureRes = await fetch(`${BaseUrl}/api/employer/check-feature?employerId=${employerId}&feature=employer_custom_chat_message`);
            const featureData = await featureRes.json();

            if (featureData.allowed) return true;

            if (featureData.reason === 'no_subscription' || featureData.reason === 'feature_not_in_plan') {
                await Swal.fire({
                    icon: 'warning',
                    title: 'Upgrade Required',
                    text: 'Your current subscription does not include direct messaging.',
                    confirmButtonText: 'View Plans',
                    showCancelButton: true
                }).then(r => { if (r.isConfirmed) navigate('/subscriptionplans'); });
                return false;
            }

            if (featureData.reason === 'limit_reached') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Limit Reached',
                    text: `You have used all ${featureData.limit} custom messages for your plan.`
                });
                return false;
            }

            if (featureData.reason === 'insufficient_wallet') {
                await Swal.fire({
                    icon: 'warning',
                    title: 'Insufficient Balance',
                    text: `Your wallet balance (${featureData.balance}) is less than the message cost (${featureData.required}).`,
                    confirmButtonText: 'View Plans',
                    showCancelButton: true
                }).then(r => { if (r.isConfirmed) navigate('/subscriptionplans'); });
                return false;
            }

            Swal.fire({
                icon: 'warning',
                title: 'Messaging Locked',
                text: 'Messaging is not available for your current plan.'
            });
            return false;
        } catch (error) {
            console.error('Message feature check failed:', error);
            return true;
        }
    };

    const resetAllFilters = () => {
        setJobPosition({
            maid: false, driver: false, cook: false, nanny: false, nurse: false, houseboy: false,
            tailor: false, teacher: false, trainer: false, gardener: false, butler: false, housekeeper: false,
            laundryWorker: false, personalAssistant: false, caregiver: false, elderCareCompanion: false,
            petSitter: false, houseManager: false, cleaner: false, maintenanceWorker: false,
            babySitter: false, tutor: false, chauffeur: false, housemaid: false, kitchenStaff: false,
            diningRoomAttendant: false, personalChef: false, eventCoordinator: false,
            householdAdministrator: false, domesticAssistant: false
        });
        setCandidateLocation({
            india: false,
            bangladesh: false,
            nepal: false,
            sriLanka: false,
            pakistan: false,
            philippines: false,
            indonesia: false,
            myanmar: false,
            vietnam: false,
            cambodia: false,
            thailand: false,
            ethiopia: false,
            kenya: false,
            uganda: false,
            tanzania: false,
            rwanda: false,
            ghana: false,
            nigeria: false,
            sierraLeone: false,
            burundi: false
        });

        // Inside resetAllFilters function, add this:
        setJobCountry({
            qatar: false,
            uae: false,
            saudiArabia: false,
            kuwait: false,
            bahrain: false,
            oman: false,
            usa: false,
            canada: false,
            uk: false,
            australia: false,
            germany: false,
            france: false,
            italy: false,
            spain: false,
            netherlands: false,
            belgium: false,
            switzerland: false,
            sweden: false,
            norway: false,
            denmark: false,
            finland: false,
            japan: false,
            southKorea: false,
            singapore: false,
            malaysia: false,
            china: false,
            hongKong: false,
            newZealand: false,
            southAfrica: false,
            brazil: false,
            mexico: false,
            argentina: false,
            chile: false,
            colombia: false,
            peru: false,
            egypt: false,
            morocco: false,
            algeria: false,
            tunisia: false,
            jordan: false,
            lebanon: false,
            iraq: false,
            iran: false,
            turkey: false,
            cyprus: false,
            malta: false,
            greece: false,
            portugal: false,
            austria: false,
            hungary: false,
            poland: false,
            czechRepublic: false,
            slovakia: false,
            slovenia: false,
            croatia: false,
            romania: false,
            bulgaria: false,
            serbia: false,
            montenegro: false,
            albania: false,
            northMacedonia: false,
            bosniaHerzegovina: false,
            kosovo: false,
            estonia: false,
            latvia: false,
            lithuania: false,
            belarus: false,
            ukraine: false,
            moldova: false,
            georgia: false,
            armenia: false,
            azerbaijan: false,
            kazakhstan: false,
            uzbekistan: false,
            turkmenistan: false,
            kyrgyzstan: false,
            tajikistan: false,
            afghanistan: false,
            pakistan: false,
            india: false,
            bangladesh: false,
            sriLanka: false,
            nepal: false,
            bhutan: false,
            myanmar: false,
            thailand: false,
            laos: false,
            cambodia: false,
            vietnam: false,
            indonesia: false,
            philippines: false,
            brunei: false,
            eastTimor: false,
            papuaNewGuinea: false,
            fiji: false,
            solomonIslands: false,
            vanuatu: false,
            samoa: false,
            tonga: false,
            marshallIslands: false,
            micronesia: false,
            palau: false,
            nauru: false,
            tuvalu: false,
            kiribati: false
        });
        setJobType({
            fullTime: false, partTime: false, liveIn: false, liveOut: false, temporary: false,
            permanent: false, internship: false, contractual: false, freelance: false,
            volunteer: false, fresher: false
        });
        setContractStatus({ permanent: false, temporary: false, contract: false });
        setPostedBy({ agency: false, directEmployer: false });
        setLanguage({
            english: false, mandarin: false, arabic: false, hindi: false, tagalog: false,
            cantonese: false, malay: false, tamil: false
        });
        setMainSkills({
            childcare: false, elderlyCare: false, cooking: false, cleaning: false,
            laundry: false, ironing: false, petCare: false, gardening: false
        });
        setStartDate('');
    };

    const handleCandidateLocationChange = (e) => {
        const { name, checked } = e.target;
        setCandidateLocation(prev => ({ ...prev, [name]: checked }));
    };

    const handleJobTypeChange = (e) => {
        const { name, checked } = e.target;
        setJobType(prev => ({ ...prev, [name]: checked }));
    };

    const handleContractStatusChange = (e) => {
        const { name, checked } = e.target;
        setContractStatus(prev => ({ ...prev, [name]: checked }));
    };

    const handlePostedByChange = (e) => {
        const { name, checked } = e.target;
        setPostedBy(prev => ({ ...prev, [name]: checked }));
    };

    const handleLanguageChange = (e) => {
        const { name, checked } = e.target;
        setLanguage(prev => ({ ...prev, [name]: checked }));
    };

    const handleMainSkillsChange = (e) => {
        const { name, checked } = e.target;
        setMainSkills(prev => ({ ...prev, [name]: checked }));
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const toggleMoreLocations = () => {
        setShowMoreLocations(!showMoreLocations);
    };

    // In Candidates.js, add this function
    const recordView = async (candidateUserId, candidateFirstName) => {
        try {
            const user = JSON.parse(localStorage.getItem("user")) || {};
            const employerUserId = user.id || '';
            const employerName = user.emp_name || user.company_name || 'Employer';

            const response = await fetch(`${BaseUrl}/api/viewed-profiles/record-view`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    employer_user_id: employerUserId,
                    employer_name: employerName,
                    candidate_user_id: candidateUserId,
                    candidate_name: candidateFirstName
                })
            });

            // Don't wait for response - fire and forget
            return true;
        } catch (error) {
            console.log('View recording failed silently:', error);
            return false;
        }
    };

    // Update handleViewClick
    const handleViewClick = async (userId, first_name) => {
        // Record view in background
        recordView(userId, first_name);

        // Navigate immediately
        navigate(`/candidateview/${userId}/${first_name}`);
    };

    const handleMessageClick = async (candidate) => {
        const canAccessMessage = await checkEmployerMessageFeature();
        if (!canAccessMessage) {
            return;
        }
        setSelectedCandidate(candidate);
        // Set message content with candidate name
        const candidateName = candidate.first_name?.split('@')[0] || 'Candidate';
        setMessageContent(`Hello ${candidateName}, I am interested in your profile. Please let me know if you are interested in working with me.`);
        setShowMessageModal(true);

        // Fetch messages immediately when modal opens
        await fetchMessages(employerId, candidate.user_id);
    };

    const handleCloseMessageModal = () => {
        setShowMessageModal(false);
        setMessageContent('');
        setSelectedCandidate(null);
        setMessages([]); // Clear messages when modal closes
    };

    // const handleMessageContentChange = (e) => {
    //     setMessageContent(e.target.value);
    // };

    // Update the fetchMessages function to properly differentiate sender
    const fetchMessages = async (employerId, jobSeekerId) => {
        try {
            const response = await fetch(`${BaseUrl}/message/${employerId}/${jobSeekerId}/get`);
            if (!response.ok) {
                throw new Error('Failed to fetch messages');
            }
            const data = await response.json();

            // Format messages to identify sender correctly
            const formattedMessages = data.map(msg => ({
                ...msg,
                // If sender_id matches current employer ID, it's from employer, otherwise from candidate
                sender: msg.sender_id === employerId ? 'employer' : 'candidate',
                senderName: msg.sender_id === employerId ? 'You' : (selectedCandidate?.first_name?.split('@')[0] || 'Candidate')
            }));

            setMessages(formattedMessages);
        } catch (error) {
            console.error('Error fetching messages:', error);
            setMessages([]); // Set empty array on error
        }
    };

    useEffect(() => {
        const fetchShortlistedStatus = async () => {
            try {
                const response = await fetch(`${BaseUrl}/shortlist/employer/${employerId}`);
                if (response.ok) {
                    const data = await response.json();
                    const shortlistedMap = {};
                    data.forEach(entry => {
                        shortlistedMap[entry.user_id] = entry.id;
                    });
                    setShortlistedCandidates(shortlistedMap);
                }
            } catch (error) {
                console.error('Error fetching shortlisted status:', error);
            }
        };

        if (employerId) {
            fetchShortlistedStatus();
        }
    }, [employerId]);

    const handleShortlistClick = async (candidate) => {
        const shortlistLimitInfo = getShortlistLimitInfo();
        if (!shortlistLimitInfo.canUse) {
            Swal.fire({
                icon: 'warning',
                title: 'Feature Not Available',
                text: shortlistLimitInfo.message,
            });
            return;
        }

        const candidateUserId = candidate.user_id;
        const isCurrentlyShortlisted = shortlistedCandidates[candidateUserId];

        try {
            Swal.fire({
                title: isCurrentlyShortlisted ? 'Removing from shortlist...' : 'Adding to shortlist...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            if (isCurrentlyShortlisted) {
                const shortlistEntryId = shortlistedCandidates[candidateUserId];
                const response = await fetch(`${BaseUrl}/shortlist/${shortlistEntryId}`, {
                    method: 'DELETE',
                });

                if (!response.ok) {
                    throw new Error('Failed to remove candidate from shortlist');
                }

                setShortlistedCandidates(prev => {
                    const newState = { ...prev };
                    delete newState[candidateUserId];
                    return newState;
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Removed!',
                    text: 'Candidate removed from shortlist successfully!',
                    confirmButtonText: 'OK',
                });
            } else {
                const shortlistData = {
                    user_id: candidateUserId,
                    employer_id: employerId,
                    employer_source: "Direct",
                    first_name: candidate.first_name?.split('@')[0] || candidate.first_name || 'Candidate',
                    email_id: candidate.email_id || candidate.email || ''
                };

                const response = await fetch(`${BaseUrl}/shortlist`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(shortlistData)
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Failed to add candidate to shortlist');
                }

                setShortlistedCandidates(prev => ({
                    ...prev,
                    [candidateUserId]: data.data.id
                }));

                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Candidate added to shortlist successfully!',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            console.error('Error toggling shortlist:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: error.message || 'An error occurred. Please try again.',
            });
        }
    };

    const handleShareClick = (candidate) => {
        const shareLimitInfo = getShareLimitInfo();
        if (!shareLimitInfo.canUse) {
            Swal.fire({
                icon: 'warning',
                title: 'Feature Not Available',
                text: shareLimitInfo.message,
            });
            return;
        }

        const candidateName = candidate.first_name?.split('@')[0] || 'Candidate';
        const candidateAge = candidate.age ? `${candidate.age} years` : '';
        const nationality = candidate.nationality || '';
        const jobPositionStr = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ')
            : candidate.job_position || 'Domestic Worker';
        const experience = candidate.total_work_experience || 'Not specified';
        const currentLocation = candidate.current_country || 'Not specified';

        const shareText = `Check out ${candidateName}'s profile - ${jobPositionStr} | ${nationality} | ${candidateAge} | ${experience} experience | Currently in ${currentLocation}. Find more candidates on Gulf Worker.`;
        const shareUrlVal = `${window.location.origin}/candidateview/${candidate.user_id}/${candidate.first_name}`;
        const fullShareContent = `${shareText} ${shareUrlVal}`;

        if (navigator.share) {
            navigator.share({
                title: `${candidateName} - ${jobPositionStr}`,
                text: shareText,
                url: shareUrlVal,
            })
                .catch((error) => console.log('Error sharing:', error));
        } else {
            setSelectedCandidate(candidate);
            setShareContent(fullShareContent);
            setShareUrl(shareUrlVal);
            setShowShareModal(true);
        }
    };

    const shareViaWhatsApp = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://wa.me/?text=${encodedText}`, '_blank');
    };

    const shareViaFacebook = (url) => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
    };

    const shareViaTwitter = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
    };

    const shareViaLinkedIn = (url) => {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'Copied!',
                text: 'Link copied to clipboard',
                timer: 1500,
                showConfirmButton: false
            });
        });
    };

    // Update the handleSendMessage function to include message limits
    const handleSendMessage = async () => {
        if (!messageContent.trim() || !selectedCandidate) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: 'Please select a candidate and enter a message',
            });
            return;
        }

        const canAccessMessage = await checkEmployerMessageFeature();
        if (!canAccessMessage) {
            return;
        }

        try {
            Swal.fire({
                title: 'Sending message...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const candidateName = selectedCandidate?.first_name?.split('@')[0] || 'Candidate';
            const employerName = user.emp_name || user.first_name || user.company_name || 'Employer';
            const jobPositionStr = Array.isArray(selectedCandidate.job_position)
                ? selectedCandidate.job_position.join(', ')
                : (selectedCandidate.job_position || 'candidate');

            // Create personalized message with job postings
            let personalizedMessage = `Hello ${candidateName}, I'm interested in your ${jobPositionStr} profile from Gulf Worker website. Please visit GulfWorker.net for more details.\n\n`;

            // Add job postings if available
            if (jobs && jobs.length > 0) {
                personalizedMessage += `Here are my current job postings:\n\n`;

                jobs.forEach((job, index) => {
                    const jobTitle = job.job_title || 'Job Opening';
                    const jobLocation = job.job_location || 'Not specified';
                    const salary = job.salary || 'Negotiable';
                    const jobLink = `${window.location.origin}/viewjobs`;

                    personalizedMessage += `${index + 1}. ${jobTitle}\n`;
                    personalizedMessage += `   Location: ${jobLocation}\n`;
                    personalizedMessage += `   Salary: ${salary}\n`;
                    personalizedMessage += `   View Job: ${jobLink}\n\n`;
                });
            } else {
                personalizedMessage += `I don't have any active job postings at the moment, but I'm interested in discussing potential opportunities with you.`;
            }

            const storeResponse = await fetch(`${BaseUrl}/message`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    emp_id: employerId,
                    job_seeker_id: selectedCandidate.user_id,
                    message: messageContent // Send custom message content
                })
            });

            if (!storeResponse.ok) {
                const errorData = await storeResponse.json();
                throw new Error(errorData.error || 'Failed to store message');
            }

            const storeData = await storeResponse.json();

            // Increment message count for free users and free trial users
            if (!planName || planName.toLowerCase() === 'free') {
                const newMessageCount = dailyMessageCount + 1;
                setDailyMessageCount(newMessageCount);
                localStorage.setItem('dailyMessageCount', newMessageCount.toString());
            }

            // Optional: Send email
            // Send email to candidate with proper HTML formatting
            try {
                // Get employer details
                const user = JSON.parse(localStorage.getItem("user")) || {};
                const employerName = user.emp_name || user.first_name || user.company_name || 'Employer';
                const profileLink = `${window.location.origin}/viewjobs`;

                // Create HTML formatted email message
                // Create HTML formatted email message
                const emailMessageHTML = `
<div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
  <h2 style="color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 10px;">
    New Message from Employer
  </h2>
  
  <div style="margin: 20px 0; padding: 15px; background-color: #f8f9fa; border-left: 4px solid #3498db;">
    <p style="margin: 0 0 10px 0;"><strong>Message:</strong></p>
    <p style="margin: 0; font-style: italic;">${personalizedMessage.replace(/\n/g, '<br>')}</p>
  </div>
  
  <h3 style="color: #2c3e50; margin-top: 25px;">Employer Details:</h3>
  <table style="width: 100%; border-collapse: collapse; margin: 15px 0;">
    <tr style="background-color: #f8f9fa;">
      <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold; width: 150px;">Employer:</td>
      <td style="padding: 10px; border: 1px solid #ddd;">${employerName}</td>
    </tr>
    <tr>
      <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">View Job Postings:</td>
      <td style="padding: 10px; border: 1px solid #ddd;">
        <a href="${window.location.origin}/viewjobs" style="color: #3498db; text-decoration: none;">
          Click here to view all my job postings
        </a>
      </td>
    </tr>
  </table>
  
  <div style="margin-top: 30px; padding: 15px; background-color: #e8f5e9; border-radius: 5px;">
    <p style="margin: 0; color: #2e7d32;">
      <strong>📧 This message was sent via Gulf Worker platform</strong>
    </p>
  </div>
  
  <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;">
  
  <p style="color: #7f8c8d; font-size: 12px; margin-top: 20px;">
    This is an automated message from Gulf Worker job portal. Please do not reply to this email.
  </p>
</div>
`;

                // Alternative: Plain text version
                const emailMessagePlainText =
                    `New Message from Employer\n\n` +
                    `Message: ${personalizedMessage}\n\n` +
                    `Employer Details:\n` +
                    `Employer: ${employerName}\n` +
                    `View Job Postings: ${window.location.origin}/viewjobs\n\n` +
                    `---\n\n` +
                    `This message was sent via Gulf Worker platform. Please log in to your account to respond.\n\n` +
                    `Best regards,\nGulf Worker Team`;

                const emailSubject = `New Job Opportunity from ${employerName} - Gulf Worker`;

                const emailResponse = await fetch(`${BaseUrl}/api/send-email`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        to_email: selectedCandidate.email_id,
                        subject: emailSubject,
                        message: emailMessageHTML,
                        text_message: emailMessagePlainText
                    })
                });

                if (!emailResponse.ok) {
                    console.warn('Email sending failed, but message was stored');
                }
            } catch (emailError) {
                console.warn('Email sending failed:', emailError);
            }

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Message sent successfully!',
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                setMessageContent("I'm interested");
                fetchMessages(employerId, selectedCandidate.user_id);
            });
        } catch (error) {
            console.error('Error sending message:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed to send message',
                text: error.message || 'Please try again later.',
            });
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    const safeParseArray = (field) => {
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const handleReportClick = (candidate) => {
        setSelectedCandidateForReport(candidate);
        setShowReportModal(true);
    };

    const getCandidatesApiUrl = (pageToLoad) => {
        const params = new URLSearchParams({
            paginated: '1',
            page: String(pageToLoad),
            limit: String(PAGE_SIZE)
        });

        if (categoryFilter === 'company-worker') {
            params.set('segment', 'company-worker');
        }

        return `${BaseUrl}/api/job-seeker/combine/all?${params.toString()}`;
    };

    const fetchCandidatesPage = async (pageNumber) => {
        const response = await fetch(getCandidatesApiUrl(pageNumber));
        if (!response.ok) throw new Error('Failed to fetch candidates');

        let data = await response.json();
        const paginatedPayload = data;

        if (!Array.isArray(data)) {
            if (data.data && Array.isArray(data.data)) data = data.data;
            else if (data.candidates && Array.isArray(data.candidates)) data = data.candidates;
            else if (data.users && Array.isArray(data.users)) data = data.users;
            else data = [];
        }

        // Filter and format
        data = data.filter(isVerifiedCandidate).map(candidate => ({
            ...candidate,
            language: safeParseArray(candidate.language),
            main_skills: safeParseArray(candidate.main_skills),
            preferred_countries: safeParseArray(candidate.preferred_countries),
            work_experience: safeParseArray(candidate.work_experience),
            job_position: safeParseArray(candidate.job_position),
            profile_photo: candidate.profile_photo ? `${BaseUrl}${candidate.profile_photo}` : candidate.profile_photo
        }));

        return { data, hasMore: Boolean(paginatedPayload?.hasMore) };
    };

    const isVerifiedCandidate = (candidate) => {
        return candidate && candidate.verification_status?.toLowerCase() === 'verified';
    };

    // Fetch all candidates and applied user IDs
    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                // Step 1: Fetch application data to get applied user IDs
                const appResponse = await fetch(`${BaseUrl}/api/applications`);
                if (appResponse.ok) {
                    const applications = await appResponse.json();
                    const appliedIds = applications
                        .filter(app => app.status === 'Applied' && app.empuserid === employerId)
                        .map(app => app.userid);
                    setAppliedUserIds(appliedIds);
                }

                // Step 2: Fetch candidates with loop
                let { data: currentCandidates, hasMore: currentHasMore } = await fetchCandidatesPage(1);
                let currentPage = 1;

                while (currentCandidates.length < 9 && currentHasMore) {
                    currentPage++;
                    const result = await fetchCandidatesPage(currentPage);
                    currentCandidates = [...currentCandidates, ...result.data];
                    currentHasMore = result.hasMore;
                }

                setCandidates(currentCandidates);
                setFilteredCandidates(currentCandidates);
                setPage(currentPage);
                setHasMore(currentHasMore);

            } catch (err) {
                setError(err.message);
                setCandidates([]);
                setFilteredCandidates([]);
            } finally {
                setLoading(false);
            }
        };

        if (employerId) {
            fetchCandidates();
        }
    }, [employerId, categoryFilter]);

    // Apply search and sidebar filters to the loaded candidate set
    useEffect(() => {
        let result = [...candidates];

        // Step 1: Filter by All vs Applicants
        if (activeFilter === 'applicants') {
            result = result.filter(candidate => appliedUserIds.includes(candidate.user_id));
        }

        if (categoryFilter === 'company-worker') {
            result = result.filter(candidate => {
                const category = (candidate.category || '').toString().toLowerCase();
                return category.includes('company');
            });
        }

        // Step 2: Apply other filters
        if (Object.values(jobPosition).some(v => v)) {
            result = result.filter(candidate => {
                const jobPositions = Array.isArray(candidate.job_position)
                    ? candidate.job_position.map(pos => pos?.toLowerCase() || '')
                    : [candidate.job_position?.toLowerCase() || ''];

                const jobPositionsString = jobPositions.join(' ');

                return (
                    (jobPosition.maid && jobPositionsString.includes('maid')) ||
                    (jobPosition.driver && jobPositionsString.includes('driver')) ||
                    (jobPosition.cook && jobPositionsString.includes('cook')) ||
                    (jobPosition.nanny && jobPositionsString.includes('nanny')) ||
                    (jobPosition.nurse && jobPositionsString.includes('nurse')) ||
                    (jobPosition.houseboy && jobPositionsString.includes('houseboy')) ||
                    (jobPosition.tailor && jobPositionsString.includes('tailor')) ||
                    (jobPosition.teacher && jobPositionsString.includes('teacher')) ||
                    (jobPosition.trainer && jobPositionsString.includes('trainer')) ||
                    (jobPosition.gardener && jobPositionsString.includes('gardener')) ||
                    (jobPosition.butler && jobPositionsString.includes('butler')) ||
                    (jobPosition.housekeeper && jobPositionsString.includes('housekeeper')) ||
                    (jobPosition.laundryWorker && jobPositionsString.includes('laundry')) ||
                    (jobPosition.personalAssistant && jobPositionsString.includes('personal assistant')) ||
                    (jobPosition.caregiver && jobPositionsString.includes('caregiver')) ||
                    (jobPosition.elderCareCompanion && jobPositionsString.includes('elder care')) ||
                    (jobPosition.petSitter && (jobPositionsString.includes('pet') || jobPositionsString.includes('dog walker'))) ||
                    (jobPosition.houseManager && jobPositionsString.includes('house manager')) ||
                    (jobPosition.cleaner && jobPositionsString.includes('cleaner')) ||
                    (jobPosition.maintenanceWorker && (jobPositionsString.includes('maintenance') || jobPositionsString.includes('handyman'))) ||
                    (jobPosition.babySitter && jobPositionsString.includes('baby sitter')) ||
                    (jobPosition.tutor && jobPositionsString.includes('tutor')) ||
                    (jobPosition.chauffeur && jobPositionsString.includes('chauffeur')) ||
                    (jobPosition.housemaid && jobPositionsString.includes('housemaid')) ||
                    (jobPosition.kitchenStaff && jobPositionsString.includes('kitchen staff')) ||
                    (jobPosition.diningRoomAttendant && jobPositionsString.includes('dining room')) ||
                    (jobPosition.personalChef && jobPositionsString.includes('personal chef')) ||
                    (jobPosition.eventCoordinator && jobPositionsString.includes('event coordinator')) ||
                    (jobPosition.householdAdministrator && jobPositionsString.includes('household administrator')) ||
                    (jobPosition.domesticAssistant && jobPositionsString.includes('domestic assistant'))
                );
            });
        }

        // Filter by job country (using country_apply_for_job field)
        if (Object.values(jobCountry).some(v => v)) {
            result = result.filter(candidate => {
                const applyForCountry = candidate.country_apply_for_job?.toLowerCase() || '';
                return (
                    (jobCountry.qatar && applyForCountry.includes('qatar')) ||
                    (jobCountry.uae && (applyForCountry.includes('uae') || applyForCountry.includes('united arab emirates') || applyForCountry.includes('dubai') || applyForCountry.includes('abu dhabi'))) ||
                    (jobCountry.saudiArabia && (applyForCountry.includes('saudi') || applyForCountry.includes('ksa') || applyForCountry.includes('riyadh') || applyForCountry.includes('jeddah'))) ||
                    (jobCountry.kuwait && applyForCountry.includes('kuwait')) ||
                    (jobCountry.bahrain && applyForCountry.includes('bahrain')) ||
                    (jobCountry.oman && applyForCountry.includes('oman')) ||
                    (jobCountry.usa && (applyForCountry.includes('usa') || applyForCountry.includes('united states') || applyForCountry.includes('america'))) ||
                    (jobCountry.canada && applyForCountry.includes('canada')) ||
                    (jobCountry.uk && (applyForCountry.includes('uk') || applyForCountry.includes('united kingdom') || applyForCountry.includes('england') || applyForCountry.includes('britain'))) ||
                    (jobCountry.australia && applyForCountry.includes('australia')) ||
                    (jobCountry.germany && applyForCountry.includes('germany')) ||
                    (jobCountry.france && applyForCountry.includes('france')) ||
                    (jobCountry.italy && applyForCountry.includes('italy')) ||
                    (jobCountry.spain && applyForCountry.includes('spain')) ||
                    (jobCountry.netherlands && applyForCountry.includes('netherlands')) ||
                    (jobCountry.belgium && applyForCountry.includes('belgium')) ||
                    (jobCountry.switzerland && applyForCountry.includes('switzerland')) ||
                    (jobCountry.sweden && applyForCountry.includes('sweden')) ||
                    (jobCountry.norway && applyForCountry.includes('norway')) ||
                    (jobCountry.denmark && applyForCountry.includes('denmark')) ||
                    (jobCountry.finland && applyForCountry.includes('finland')) ||
                    (jobCountry.japan && applyForCountry.includes('japan')) ||
                    (jobCountry.southKorea && (applyForCountry.includes('south korea') || applyForCountry.includes('korea'))) ||
                    (jobCountry.singapore && applyForCountry.includes('singapore')) ||
                    (jobCountry.malaysia && applyForCountry.includes('malaysia')) ||
                    (jobCountry.china && applyForCountry.includes('china')) ||
                    (jobCountry.hongKong && (applyForCountry.includes('hong kong') || applyForCountry.includes('hongkong'))) ||
                    (jobCountry.newZealand && (applyForCountry.includes('new zealand') || applyForCountry.includes('new zealand'))) ||
                    (jobCountry.southAfrica && (applyForCountry.includes('south africa') || applyForCountry.includes('south africa'))) ||
                    (jobCountry.brazil && applyForCountry.includes('brazil')) ||
                    (jobCountry.mexico && applyForCountry.includes('mexico')) ||
                    (jobCountry.argentina && applyForCountry.includes('argentina')) ||
                    (jobCountry.chile && applyForCountry.includes('chile')) ||
                    (jobCountry.colombia && applyForCountry.includes('colombia')) ||
                    (jobCountry.peru && applyForCountry.includes('peru')) ||
                    (jobCountry.egypt && applyForCountry.includes('egypt')) ||
                    (jobCountry.morocco && applyForCountry.includes('morocco')) ||
                    (jobCountry.algeria && applyForCountry.includes('algeria')) ||
                    (jobCountry.tunisia && applyForCountry.includes('tunisia')) ||
                    (jobCountry.jordan && applyForCountry.includes('jordan')) ||
                    (jobCountry.lebanon && applyForCountry.includes('lebanon')) ||
                    (jobCountry.iraq && applyForCountry.includes('iraq')) ||
                    (jobCountry.iran && applyForCountry.includes('iran')) ||
                    (jobCountry.turkey && applyForCountry.includes('turkey')) ||
                    (jobCountry.cyprus && applyForCountry.includes('cyprus')) ||
                    (jobCountry.malta && applyForCountry.includes('malta')) ||
                    (jobCountry.greece && applyForCountry.includes('greece')) ||
                    (jobCountry.portugal && applyForCountry.includes('portugal')) ||
                    (jobCountry.austria && applyForCountry.includes('austria')) ||
                    (jobCountry.hungary && applyForCountry.includes('hungary')) ||
                    (jobCountry.poland && applyForCountry.includes('poland')) ||
                    (jobCountry.czechRepublic && (applyForCountry.includes('czech') || applyForCountry.includes('czech republic'))) ||
                    (jobCountry.slovakia && applyForCountry.includes('slovakia')) ||
                    (jobCountry.slovenia && applyForCountry.includes('slovenia')) ||
                    (jobCountry.croatia && applyForCountry.includes('croatia')) ||
                    (jobCountry.romania && applyForCountry.includes('romania')) ||
                    (jobCountry.bulgaria && applyForCountry.includes('bulgaria')) ||
                    (jobCountry.serbia && applyForCountry.includes('serbia')) ||
                    (jobCountry.montenegro && applyForCountry.includes('montenegro')) ||
                    (jobCountry.albania && applyForCountry.includes('albania')) ||
                    (jobCountry.northMacedonia && (applyForCountry.includes('north macedonia') || applyForCountry.includes('macedonia'))) ||
                    (jobCountry.bosniaHerzegovina && (applyForCountry.includes('bosnia') || applyForCountry.includes('herzegovina'))) ||
                    (jobCountry.kosovo && applyForCountry.includes('kosovo')) ||
                    (jobCountry.estonia && applyForCountry.includes('estonia')) ||
                    (jobCountry.latvia && applyForCountry.includes('latvia')) ||
                    (jobCountry.lithuania && applyForCountry.includes('lithuania')) ||
                    (jobCountry.belarus && applyForCountry.includes('belarus')) ||
                    (jobCountry.ukraine && applyForCountry.includes('ukraine')) ||
                    (jobCountry.moldova && applyForCountry.includes('moldova')) ||
                    (jobCountry.georgia && applyForCountry.includes('georgia')) ||
                    (jobCountry.armenia && applyForCountry.includes('armenia')) ||
                    (jobCountry.azerbaijan && applyForCountry.includes('azerbaijan')) ||
                    (jobCountry.kazakhstan && applyForCountry.includes('kazakhstan')) ||
                    (jobCountry.uzbekistan && applyForCountry.includes('uzbekistan')) ||
                    (jobCountry.turkmenistan && applyForCountry.includes('turkmenistan')) ||
                    (jobCountry.kyrgyzstan && applyForCountry.includes('kyrgyzstan')) ||
                    (jobCountry.tajikistan && applyForCountry.includes('tajikistan')) ||
                    (jobCountry.afghanistan && applyForCountry.includes('afghanistan')) ||
                    (jobCountry.pakistan && applyForCountry.includes('pakistan')) ||
                    (jobCountry.india && applyForCountry.includes('india')) ||
                    (jobCountry.bangladesh && applyForCountry.includes('bangladesh')) ||
                    (jobCountry.sriLanka && (applyForCountry.includes('sri lanka') || applyForCountry.includes('sri lanka'))) ||
                    (jobCountry.nepal && applyForCountry.includes('nepal')) ||
                    (jobCountry.bhutan && applyForCountry.includes('bhutan')) ||
                    (jobCountry.myanmar && applyForCountry.includes('myanmar')) ||
                    (jobCountry.thailand && applyForCountry.includes('thailand')) ||
                    (jobCountry.laos && applyForCountry.includes('laos')) ||
                    (jobCountry.cambodia && applyForCountry.includes('cambodia')) ||
                    (jobCountry.vietnam && applyForCountry.includes('vietnam')) ||
                    (jobCountry.indonesia && applyForCountry.includes('indonesia')) ||
                    (jobCountry.philippines && applyForCountry.includes('philippines')) ||
                    (jobCountry.brunei && applyForCountry.includes('brunei')) ||
                    (jobCountry.eastTimor && (applyForCountry.includes('east timor') || applyForCountry.includes('timor-leste'))) ||
                    (jobCountry.papuaNewGuinea && (applyForCountry.includes('papua new guinea') || applyForCountry.includes('papua new guinea'))) ||
                    (jobCountry.fiji && applyForCountry.includes('fiji')) ||
                    (jobCountry.solomonIslands && (applyForCountry.includes('solomon islands') || applyForCountry.includes('solomon islands'))) ||
                    (jobCountry.vanuatu && applyForCountry.includes('vanuatu')) ||
                    (jobCountry.samoa && applyForCountry.includes('samoa')) ||
                    (jobCountry.tonga && applyForCountry.includes('tonga')) ||
                    (jobCountry.marshallIslands && (applyForCountry.includes('marshall islands') || applyForCountry.includes('marshall islands'))) ||
                    (jobCountry.micronesia && applyForCountry.includes('micronesia')) ||
                    (jobCountry.palau && applyForCountry.includes('palau')) ||
                    (jobCountry.nauru && applyForCountry.includes('nauru')) ||
                    (jobCountry.tuvalu && applyForCountry.includes('tuvalu')) ||
                    (jobCountry.kiribati && applyForCountry.includes('kiribati'))
                );
            });
        }

        // Filter by candidate nationality
        const selectedLocations = [];

        if (candidateLocation.india) selectedLocations.push('india');
        if (candidateLocation.bangladesh) selectedLocations.push('bangladesh');
        if (candidateLocation.nepal) selectedLocations.push('nepal');
        if (candidateLocation.sriLanka) selectedLocations.push('sri lanka', 'sri lankan');
        if (candidateLocation.pakistan) selectedLocations.push('pakistan');
        if (candidateLocation.philippines) selectedLocations.push('philippines');
        if (candidateLocation.indonesia) selectedLocations.push('indonesia');
        if (candidateLocation.myanmar) selectedLocations.push('myanmar', 'burma');
        if (candidateLocation.vietnam) selectedLocations.push('vietnam');
        if (candidateLocation.cambodia) selectedLocations.push('cambodia');
        if (candidateLocation.thailand) selectedLocations.push('thailand');
        if (candidateLocation.ethiopia) selectedLocations.push('ethiopia');
        if (candidateLocation.kenya) selectedLocations.push('kenya');
        if (candidateLocation.uganda) selectedLocations.push('uganda');
        if (candidateLocation.tanzania) selectedLocations.push('tanzania');
        if (candidateLocation.rwanda) selectedLocations.push('rwanda');
        if (candidateLocation.ghana) selectedLocations.push('ghana');
        if (candidateLocation.nigeria) selectedLocations.push('nigeria');
        if (candidateLocation.sierraLeone) selectedLocations.push('sierra leone');
        if (candidateLocation.burundi) selectedLocations.push('burundi');

        if (selectedLocations.length > 0) {
            result = result.filter(candidate => {
                const nationality = candidate.nationality?.toLowerCase() || '';
                return selectedLocations.some(location => nationality.includes(location));
            });
        }

        // Filter by job type
        if (
            jobType.fullTime || jobType.partTime || jobType.liveIn || jobType.liveOut ||
            jobType.temporary || jobType.permanent || jobType.internship || jobType.contractual ||
            jobType.freelance || jobType.volunteer || jobType.fresher
        ) {
            result = result.filter(candidate => {
                const type = candidate.job_type?.toLowerCase() || '';
                return (
                    (jobType.fullTime && type.includes('full time')) ||
                    (jobType.partTime && type.includes('part time')) ||
                    (jobType.liveIn && type.includes('live in')) ||
                    (jobType.liveOut && type.includes('live out')) ||
                    (jobType.temporary && type.includes('temporary')) ||
                    (jobType.permanent && type.includes('permanent')) ||
                    (jobType.internship && type.includes('internship')) ||
                    (jobType.contractual && type.includes('contractual')) ||
                    (jobType.freelance && type.includes('freelance')) ||
                    (jobType.volunteer && type.includes('volunteer')) ||
                    (jobType.fresher && type.includes('fresher'))
                );
            });
        }

        // Filter by contract status
        if (contractStatus.permanent || contractStatus.temporary || contractStatus.contract) {
            result = result.filter(candidate => {
                const status = candidate.visa_type?.toLowerCase();
                return (contractStatus.permanent && status?.includes('permanent')) ||
                    (contractStatus.temporary && status?.includes('temporary')) ||
                    (contractStatus.contract && status?.includes('contract'));
            });
        }

        // Filter by posted by
        if (postedBy.agency || postedBy.directEmployer) {
            result = result.filter(candidate => {
                const source = candidate.source?.toLowerCase();
                return (postedBy.agency && source?.includes('agency')) ||
                    (postedBy.directEmployer && source?.includes('direct'));
            });
        }

        // Filter by language
        if (
            language.english || language.mandarin || language.arabic || language.hindi ||
            language.tagalog || language.cantonese || language.malay || language.tamil
        ) {
            result = result.filter(candidate => {
                const langs = candidate.language?.map(l => l.language?.toLowerCase()).join(' ') || '';
                return (
                    (language.english && langs.includes('english')) ||
                    (language.mandarin && langs.includes('mandarin')) ||
                    (language.arabic && langs.includes('arabic')) ||
                    (language.hindi && langs.includes('hindi')) ||
                    (language.tagalog && langs.includes('tagalog')) ||
                    (language.cantonese && langs.includes('cantonese')) ||
                    (language.malay && langs.includes('malay')) ||
                    (language.tamil && langs.includes('tamil'))
                );
            });
        }

        // Filter by main skills
        if (
            mainSkills.childcare || mainSkills.elderlyCare || mainSkills.cooking ||
            mainSkills.cleaning || mainSkills.laundry || mainSkills.ironing ||
            mainSkills.petCare || mainSkills.gardening
        ) {
            result = result.filter(candidate => {
                const skills = candidate.main_skills?.join(' ').toLowerCase() || '';
                return (
                    (mainSkills.childcare && skills.includes('childcare')) ||
                    (mainSkills.elderlyCare && skills.includes('elderly care')) ||
                    (mainSkills.cooking && skills.includes('cooking')) ||
                    (mainSkills.cleaning && skills.includes('cleaning')) ||
                    (mainSkills.laundry && skills.includes('laundry')) ||
                    (mainSkills.ironing && skills.includes('ironing')) ||
                    (mainSkills.petCare && skills.includes('pet care')) ||
                    (mainSkills.gardening && skills.includes('gardening'))
                );
            });
        }

        // Filter by start date
        if (startDate) {
            try {
                const selectedDate = new Date(startDate);
                selectedDate.setHours(0, 0, 0, 0);

                result = result.filter(candidate => {
                    if (!candidate.preferred_start_date) return false;

                    try {
                        const candidateDate = new Date(candidate.preferred_start_date);
                        candidateDate.setHours(0, 0, 0, 0);
                        return candidateDate >= selectedDate;
                    } catch (e) {
                        console.error('Error parsing candidate date:', candidate.preferred_start_date, e);
                        return false;
                    }
                });
            } catch (e) {
                console.error('Error parsing selected date:', startDate, e);
            }
        }

        if (searchTerm) {
            result = result.filter(candidate => {
                const firstName = (candidate.first_name || '').split('@')[0].toLowerCase();
                const fullName = [candidate.first_name, candidate.last_name]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase();
                const nationality = (candidate.nationality || '').toLowerCase();
                const category = (candidate.category || '').toLowerCase();
                const currentCountry = (
                    candidate.current_country ||
                    candidate.current_location ||
                    candidate.country ||
                    candidate.country_name ||
                    ''
                ).toLowerCase();
                const jobPositions = Array.isArray(candidate.job_position)
                    ? candidate.job_position.map(pos => String(pos || '').toLowerCase()).join(' ')
                    : String(candidate.job_position || '').toLowerCase();

                return (
                    firstName.includes(searchTerm) ||
                    fullName.includes(searchTerm) ||
                    nationality.includes(searchTerm) ||
                    category.includes(searchTerm) ||
                    currentCountry.includes(searchTerm) ||
                    jobPositions.includes(searchTerm)
                );
            });
        }

        setFilteredCandidates(result);
    }, [
        candidates,
        activeFilter,
        categoryFilter,
        jobPosition,
        candidateLocation,
        jobCountry,
        jobType,
        contractStatus,
        postedBy,
        language,
        mainSkills,
        startDate,
        appliedUserIds,
        searchTerm
    ]);

    // Reset visible count only when user changes filters
    useEffect(() => {
        setVisibleCount(9);
    }, [activeFilter, categoryFilter, jobPosition, candidateLocation, jobCountry, jobType, contractStatus, postedBy, language, mainSkills, startDate, searchTerm]);

    const loadRemainingCandidatePages = async () => {
        let nextPage = page;
        let nextHasMore = hasMore;
        let loadedCandidates = [...candidates];

        while (nextHasMore) {
            const response = await fetch(getCandidatesApiUrl(nextPage + 1));
            if (!response.ok) {
                throw new Error('Failed to fetch candidates');
            }

            let data = await response.json();
            const paginatedPayload = data;

            if (!Array.isArray(data)) {
                if (data.data && Array.isArray(data.data)) {
                    data = data.data;
                } else if (data.candidates && Array.isArray(data.candidates)) {
                    data = data.candidates;
                } else if (data.users && Array.isArray(data.users)) {
                    data = data.users;
                } else {
                    data = [];
                }
            }

            data = data.filter(candidate => {
                if (!candidate) return false;
                return candidate.verification_status?.toLowerCase() === 'verified';
            });

            data = data.map(candidate => ({
                ...candidate,
                language: safeParseArray(candidate.language),
                main_skills: safeParseArray(candidate.main_skills),
                preferred_countries: safeParseArray(candidate.preferred_countries),
                work_experience: safeParseArray(candidate.work_experience),
                job_position: safeParseArray(candidate.job_position)
            }));

            const updatedData = data.map(candidate => {
                if (candidate && candidate.profile_photo) {
                    return {
                        ...candidate,
                        profile_photo: `${BaseUrl}${candidate.profile_photo}`
                    };
                }
                return candidate;
            });

            nextPage += 1;
            nextHasMore = Boolean(paginatedPayload?.hasMore);
            loadedCandidates = mergeUniqueCandidates(loadedCandidates, updatedData);
        }

        setCandidates(loadedCandidates);
        setPage(nextPage);
        setHasMore(nextHasMore);
    };

    const applySearchTerm = async (rawSearchValue) => {
        const nextSearchTerm = rawSearchValue.trim().toLowerCase();

        if (nextSearchTerm && hasMore) {
            try {
                setLoadingMore(true);
                await loadRemainingCandidatePages();
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingMore(false);
            }
        }

        setSearchTerm(nextSearchTerm);
    };

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        await applySearchTerm(searchInput);
    };

    const handleLoadMore = async () => {
        const nextVisible = visibleCount + 9;
        setVisibleCount(nextVisible);

        if (nextVisible >= filteredCandidates.length && hasMore && !loadingMore) {
            try {
                setLoadingMore(true);
                let currentCandidates = [...candidates];
                let currentHasMore = hasMore;
                let currentPage = page;

                while (currentHasMore && currentCandidates.filter(isVerifiedCandidate).length < nextVisible) {
                    const result = await fetchCandidatesPage(currentPage + 1);
                    currentHasMore = result.hasMore;
                    currentPage++;
                    currentCandidates = mergeUniqueCandidates(currentCandidates, result.data);
                    
                    if (result.data.length === 0) break;
                }

                setCandidates(currentCandidates);
                setPage(currentPage);
                setHasMore(currentHasMore);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoadingMore(false);
            }
        }
    };

    useEffect(() => {
        if (autoSearchTimeoutRef.current) {
            clearTimeout(autoSearchTimeoutRef.current);
        }

        autoSearchTimeoutRef.current = setTimeout(async () => {
            if (isAutoSearchingRef.current) return;

            const normalizedSearchInput = searchInput.trim().toLowerCase();
            if (normalizedSearchInput === searchTerm) return;

            isAutoSearchingRef.current = true;
            try {
                await applySearchTerm(searchInput);
            } finally {
                isAutoSearchingRef.current = false;
            }
        }, 350);

        return () => {
            if (autoSearchTimeoutRef.current) {
                clearTimeout(autoSearchTimeoutRef.current);
            }
        };
    }, [searchInput, searchTerm, hasMore, page, candidates]);

    if (loading) {
        return (
            <>
                <EmployerNavbar />
                <div className="text-center mt-5">Loading candidates...</div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <EmployerNavbar />
                <div className="text-center mt-5 text-danger">Error: {error}</div>
            </>
        );
    }

    return (
        <>
            <EmployerNavbar />
            <Container fluid className="p-3">
                {/* Message Modal */}
                <Modal show={showMessageModal} onHide={handleCloseMessageModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Message {selectedCandidate?.first_name?.split('@')[0]}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="messageContent">
                            <Form.Label>Your Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={messageContent}
                                onChange={(e) => setMessageContent(e.target.value)}
                                placeholder={`Write your message to ${selectedCandidate?.first_name?.split('@')[0]}...`}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseMessageModal}>
                            Close
                        </Button>
                        <Button 
                            variant="primary"
                            onClick={handleSendMessage}
                            disabled={!messageContent.trim()}
                        >
                            Send Message
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Share Candidate Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p className="mb-4">Share this candidate profile via:</p>

                        <div className="d-flex justify-content-center gap-3 mb-4">
                            <Button
                                variant="success"
                                className="rounded-circle share-btn"
                                onClick={() => shareViaWhatsApp(shareContent)}
                            >
                                <i className="bi bi-whatsapp fs-4"></i>
                            </Button>

                            <Button
                                variant="primary"
                                className="rounded-circle share-btn"
                                onClick={() => shareViaFacebook(shareUrl)}
                            >
                                <i className="bi bi-facebook fs-4"></i>
                            </Button>

                            <Button
                                variant="info"
                                className="rounded-circle share-btn"
                                onClick={() => shareViaTwitter(shareContent)}
                            >
                                <i className="bi bi-twitter fs-4"></i>
                            </Button>

                            <Button
                                variant="primary"
                                className="rounded-circle share-btn"
                                style={{ backgroundColor: '#0077b5' }}
                                onClick={() => shareViaLinkedIn(shareUrl)}
                            >
                                <i className="bi bi-linkedin fs-4"></i>
                            </Button>

                            <Button
                                variant="secondary"
                                className="rounded-circle share-btn"
                                onClick={() => copyToClipboard(shareUrl)}
                            >
                                <i className="bi bi-link-45deg fs-4"></i>
                            </Button>
                        </div>

                        <Form.Group>
                            <Form.Label>Share this text:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={shareContent}
                                readOnly
                                onClick={(e) => e.target.select()}
                            />
                        </Form.Group>
                    </Modal.Body>
                </Modal>

                <Row style={{ marginTop: "75px" }}>
                    {/* Mobile Filter Toggle Button */}
                    {isMobile && (
                        <div className="mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                            >
                                <i className="bi bi-funnel me-2"></i>
                                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>
                    )}
                    {/* Filter Section */}
                    {(showFiltersMobile || !isMobile) && (
                        <Col md={2} lg={2}>
                            <div className="viewjobposting-filters p-3 border rounded bg-light">

                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>

                                {/* Candidate Nationality Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowLocation(!showLocation)}
                                    >
                                        <strong>Candidate Nationality</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'india', name: 'India' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'ethiopia', name: 'Ethiopia' },
                                                { id: 'kenya', name: 'Kenya' },
                                                { id: 'uganda', name: 'Uganda' },
                                                { id: 'tanzania', name: 'Tanzania' },
                                                { id: 'rwanda', name: 'Rwanda' },
                                                { id: 'ghana', name: 'Ghana' },
                                                { id: 'nigeria', name: 'Nigeria' },
                                                { id: 'sierraLeone', name: 'Sierra Leone' },
                                                { id: 'burundi', name: 'Burundi' }
                                            ].slice(0, showMoreLocations ? 32 : 5).map((location) => (
                                                <div key={location.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`location-${location.id}`}
                                                        checked={candidateLocation[location.id]}
                                                        onChange={(e) => handleCandidateLocationChange({
                                                            target: {
                                                                name: location.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`location-${location.id}`}>
                                                        {location.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(candidateLocation).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={toggleMoreLocations}
                                                >
                                                    {showMoreLocations ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Candidate Job Country Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                    >
                                        <strong>Candidate Job Country</strong>
                                        <i className={`bi ${showMoreJobCountry ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobCountry && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                // Gulf Countries
                                                { id: 'qatar', name: 'Qatar' },
                                                { id: 'uae', name: 'UAE/Dubai' },
                                                { id: 'saudiArabia', name: 'Saudi Arabia' },
                                                { id: 'kuwait', name: 'Kuwait' },
                                                { id: 'bahrain', name: 'Bahrain' },
                                                { id: 'oman', name: 'Oman' },

                                                // North America
                                                { id: 'usa', name: 'USA' },
                                                { id: 'canada', name: 'Canada' },

                                                // Europe
                                                { id: 'uk', name: 'United Kingdom' },
                                                { id: 'germany', name: 'Germany' },
                                                { id: 'france', name: 'France' },
                                                { id: 'italy', name: 'Italy' },
                                                { id: 'spain', name: 'Spain' },
                                                { id: 'netherlands', name: 'Netherlands' },
                                                { id: 'belgium', name: 'Belgium' },
                                                { id: 'switzerland', name: 'Switzerland' },
                                                { id: 'sweden', name: 'Sweden' },
                                                { id: 'norway', name: 'Norway' },
                                                { id: 'denmark', name: 'Denmark' },
                                                { id: 'finland', name: 'Finland' },
                                                { id: 'austria', name: 'Austria' },
                                                { id: 'hungary', name: 'Hungary' },
                                                { id: 'poland', name: 'Poland' },
                                                { id: 'czechRepublic', name: 'Czech Republic' },
                                                { id: 'slovakia', name: 'Slovakia' },
                                                { id: 'slovenia', name: 'Slovenia' },
                                                { id: 'croatia', name: 'Croatia' },
                                                { id: 'romania', name: 'Romania' },
                                                { id: 'bulgaria', name: 'Bulgaria' },
                                                { id: 'serbia', name: 'Serbia' },
                                                { id: 'montenegro', name: 'Montenegro' },
                                                { id: 'albania', name: 'Albania' },
                                                { id: 'northMacedonia', name: 'North Macedonia' },
                                                { id: 'bosniaHerzegovina', name: 'Bosnia & Herzegovina' },
                                                { id: 'kosovo', name: 'Kosovo' },
                                                { id: 'estonia', name: 'Estonia' },
                                                { id: 'latvia', name: 'Latvia' },
                                                { id: 'lithuania', name: 'Lithuania' },
                                                { id: 'belarus', name: 'Belarus' },
                                                { id: 'ukraine', name: 'Ukraine' },
                                                { id: 'moldova', name: 'Moldova' },
                                                { id: 'georgia', name: 'Georgia' },
                                                { id: 'armenia', name: 'Armenia' },
                                                { id: 'azerbaijan', name: 'Azerbaijan' },

                                                // Asia Pacific
                                                { id: 'japan', name: 'Japan' },
                                                { id: 'southKorea', name: 'South Korea' },
                                                { id: 'singapore', name: 'Singapore' },
                                                { id: 'malaysia', name: 'Malaysia' },
                                                { id: 'china', name: 'China' },
                                                { id: 'hongKong', name: 'Hong Kong' },
                                                { id: 'australia', name: 'Australia' },
                                                { id: 'newZealand', name: 'New Zealand' },

                                                // South Asia
                                                { id: 'india', name: 'India' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'bhutan', name: 'Bhutan' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'laos', name: 'Laos' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'brunei', name: 'Brunei' },
                                                { id: 'eastTimor', name: 'East Timor' },

                                                // Middle East & Africa
                                                { id: 'turkey', name: 'Turkey' },
                                                { id: 'cyprus', name: 'Cyprus' },
                                                { id: 'malta', name: 'Malta' },
                                                { id: 'egypt', name: 'Egypt' },
                                                { id: 'morocco', name: 'Morocco' },
                                                { id: 'algeria', name: 'Algeria' },
                                                { id: 'tunisia', name: 'Tunisia' },
                                                { id: 'jordan', name: 'Jordan' },
                                                { id: 'lebanon', name: 'Lebanon' },
                                                { id: 'iraq', name: 'Iraq' },
                                                { id: 'iran', name: 'Iran' },
                                                { id: 'southAfrica', name: 'South Africa' },

                                                // Central Asia
                                                { id: 'kazakhstan', name: 'Kazakhstan' },
                                                { id: 'uzbekistan', name: 'Uzbekistan' },
                                                { id: 'turkmenistan', name: 'Turkmenistan' },
                                                { id: 'kyrgyzstan', name: 'Kyrgyzstan' },
                                                { id: 'tajikistan', name: 'Tajikistan' },
                                                { id: 'afghanistan', name: 'Afghanistan' },

                                                // Latin America
                                                { id: 'brazil', name: 'Brazil' },
                                                { id: 'mexico', name: 'Mexico' },
                                                { id: 'argentina', name: 'Argentina' },
                                                { id: 'chile', name: 'Chile' },
                                                { id: 'colombia', name: 'Colombia' },
                                                { id: 'peru', name: 'Peru' },

                                                // Pacific Islands
                                                { id: 'papuaNewGuinea', name: 'Papua New Guinea' },
                                                { id: 'fiji', name: 'Fiji' },
                                                { id: 'solomonIslands', name: 'Solomon Islands' },
                                                { id: 'vanuatu', name: 'Vanuatu' },
                                                { id: 'samoa', name: 'Samoa' },
                                                { id: 'tonga', name: 'Tonga' },
                                                { id: 'marshallIslands', name: 'Marshall Islands' },
                                                { id: 'micronesia', name: 'Micronesia' },
                                                { id: 'palau', name: 'Palau' },
                                                { id: 'nauru', name: 'Nauru' },
                                                { id: 'tuvalu', name: 'Tuvalu' },
                                                { id: 'kiribati', name: 'Kiribati' }
                                            ].map((country) => (
                                                <div key={country.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`jobCountry-${country.id}`}
                                                        checked={jobCountry[country.id]}
                                                        onChange={(e) => handleJobCountryChange({
                                                            target: {
                                                                name: country.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobCountry-${country.id}`}>
                                                        {country.name}
                                                    </label>
                                                </div>
                                            ))}
                                            <button
                                                className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                style={{ textAlign: 'left' }}
                                                onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                            >
                                                {showMoreJobCountry ? 'Show Less' : 'Show More'}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showMoreJobPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobPosition && (
                                        <div className="d-flex flex-column  gap-2">
                                            {[
                                                { id: 'maid', name: 'Maid' },
                                                { id: 'driver', name: 'Driver' },
                                                { id: 'cook', name: 'Cook' },
                                                { id: 'nanny', name: 'Nanny' },
                                                { id: 'nurse', name: 'Nurse' },
                                                { id: 'houseboy', name: 'Houseboy' },
                                                { id: 'tailor', name: 'Tailor' },
                                                { id: 'teacher', name: 'Teacher' },
                                                { id: 'trainer', name: 'Trainer' },
                                                { id: 'gardener', name: 'Gardener' },
                                                { id: 'butler', name: 'Butler' },
                                                { id: 'housekeeper', name: 'Housekeeper' },
                                                { id: 'laundryWorker', name: 'Laundry Worker' },
                                                { id: 'personalAssistant', name: 'Personal Assistant' },
                                                { id: 'caregiver', name: 'Caregiver' },
                                                { id: 'elderCareCompanion', name: 'Elder Care Companion' },
                                                { id: 'petSitter', name: 'Pet Sitter' },
                                                { id: 'houseManager', name: 'House Manager' },
                                                { id: 'cleaner', name: 'Cleaner' },
                                                { id: 'maintenanceWorker', name: 'Maintenance Worker' },
                                                { id: 'babySitter', name: 'Baby Sitter' },
                                                { id: 'tutor', name: 'Tutor' },
                                                { id: 'chauffeur', name: 'Chauffeur' },
                                                { id: 'housemaid', name: 'Housemaid' },
                                                { id: 'kitchenStaff', name: 'Kitchen Staff' },
                                                { id: 'diningRoomAttendant', name: 'Dining Room Attendant' },
                                                { id: 'personalChef', name: 'Personal Chef' },
                                                { id: 'eventCoordinator', name: 'Event Coordinator' },
                                                { id: 'householdAdministrator', name: 'Household Administrator' },
                                                { id: 'domesticAssistant', name: 'Domestic Assistant' }
                                            ].slice(0, showMoreJobPosition ? 30 : 5).map((position) => (
                                                <div key={position.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`position-${position.id}`}
                                                        checked={jobPosition[position.id]}
                                                        onChange={(e) => handleJobPositionChange({
                                                            target: {
                                                                name: position.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`position-${position.id}`}>
                                                        {position.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobPosition).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                                >
                                                    {showMoreJobPosition ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobType(!showMoreJobType)}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showMoreJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobType && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'fullTime', name: 'Full Time' },
                                                { id: 'partTime', name: 'Part Time' },
                                                { id: 'liveIn', name: 'Live In' },
                                                { id: 'liveOut', name: 'Live Out' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'internship', name: 'Internship' },
                                                { id: 'contractual', name: 'Contractual' },
                                                { id: 'freelance', name: 'Freelance' },
                                                { id: 'volunteer', name: 'Volunteer' },
                                                { id: 'fresher', name: 'Fresher' }
                                            ].slice(0, showMoreJobType ? 11 : 5).map((type) => (
                                                <div key={type.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`jobType-${type.id}`}
                                                        checked={jobType[type.id]}
                                                        onChange={(e) => handleJobTypeChange({
                                                            target: {
                                                                name: type.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobType-${type.id}`}>
                                                        {type.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobType).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreJobType(!showMoreJobType)}
                                                >
                                                    {showMoreJobType ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'contract', name: 'Contract' }
                                            ].map((status) => (
                                                <div key={status.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`contract-${status.id}`}
                                                        checked={contractStatus[status.id]}
                                                        onChange={(e) => handleContractStatusChange({
                                                            target: {
                                                                name: status.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`contract-${status.id}`}>
                                                        {status.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Posted By Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowPostedBy(!showPostedBy)}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostedBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostedBy && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'agency', name: 'Agency' },
                                                { id: 'directEmployer', name: 'Direct Employer' }
                                            ].map((post) => (
                                                <div key={post.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`postedBy-${post.id}`}
                                                        checked={postedBy[post.id]}
                                                        onChange={(e) => handlePostedByChange({
                                                            target: {
                                                                name: post.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`postedBy-${post.id}`}>
                                                        {post.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showMoreLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreLanguage && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'english', name: 'English' },
                                                { id: 'mandarin', name: 'Mandarin' },
                                                { id: 'arabic', name: 'Arabic' },
                                                { id: 'hindi', name: 'Hindi' },
                                                { id: 'tagalog', name: 'Tagalog' },
                                                { id: 'cantonese', name: 'Cantonese' },
                                                { id: 'malay', name: 'Malay' },
                                                { id: 'tamil', name: 'Tamil' }
                                            ].slice(0, showMoreLanguage ? 8 : 5).map((lang) => (
                                                <div key={lang.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`language-${lang.id}`}
                                                        checked={language[lang.id]}
                                                        onChange={(e) => handleLanguageChange({
                                                            target: {
                                                                name: lang.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`language-${lang.id}`}>
                                                        {lang.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(language).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary" style={{ textAlign: 'left' }}
                                                    onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                                >
                                                    {showMoreLanguage ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreMainSkills(!showMoreMainSkills)}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showMoreMainSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreMainSkills && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'childcare', name: 'Childcare' },
                                                { id: 'elderlyCare', name: 'Elderly Care' },
                                                { id: 'cooking', name: 'Cooking' },
                                                { id: 'cleaning', name: 'Cleaning' },
                                                { id: 'laundry', name: 'Laundry' },
                                                { id: 'ironing', name: 'Ironing' },
                                                { id: 'petCare', name: 'Pet Care' },
                                                { id: 'gardening', name: 'Gardening' }
                                            ].map((skill) => (
                                                <div key={skill.id} className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`skill-${skill.id}`}
                                                        checked={mainSkills[skill.id]}
                                                        onChange={(e) => handleMainSkillsChange({
                                                            target: {
                                                                name: skill.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                        {skill.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="p-2 bg-white rounded border">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={handleStartDateChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    )}


                    {/* Candidates List */}
                    <Col md={!isMobile ? 10 : 12} lg={showFiltersMobile || !isMobile ? 10 : 12} >
                        <div className="candidate-toolbar">
                            <Form className="candidate-toolbar-form" onSubmit={handleSearchSubmit}>
                                <div className="input-group w-100 candidate-search-group">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search by name, nationality, or job position"
                                        value={searchInput}
                                        onChange={(e) => {
                                            setSearchInput(e.target.value);
                                        }}
                                        className="candidate-search-input"
                                        style={{ minWidth: 0 }}
                                    />
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="px-3 candidate-search-button"
                                        style={{ whiteSpace: 'nowrap', flexShrink: 0, minWidth: '78px' }}
                                    >
                                        Search
                                    </Button>
                                </div>
                            </Form>
                            <Button
                                type="button"
                                variant="success"
                                className="candidate-send-alert-button"
                                onClick={() => navigate('/employer-send-alert')}
                            >
                                <HiOutlineBellAlert className="me-2" />
                                Send Bulk Messages
                            </Button>
                        </div>
                        {filteredCandidates.length === 0 ? (
                            <div className="text-center no-jobs-message">No candidates match your filters</div>
                        ) : (
                            <Row>

                                {filteredCandidates.slice(0, visibleCount).map((candidate) => (
                                    <Col lg={4} md={6} sm={12} xs={12} className="mb-4 d-flex" key={candidate.id}>
                                        <CandidateCard
                                            candidate={candidate}
                                            planName={planName}
                                            userPlanStartDate={user.plan_startdate}
                                            userPlanEndDate={user.plan_enddate}
                                            onViewClick={() => handleViewClick(candidate.user_id, candidate.first_name)}
                                            onMessageClick={() => handleMessageClick(candidate)}
                                            onReportClick={() => handleReportClick(candidate)}
                                            onShareClick={handleShareClick}
                                            onCallClick={handleCallClick}
                                            onWhatsAppClick={handleWhatsAppClick}
                                            onShortlistClick={() => handleShortlistClick(candidate)}
                                            isShortlisted={!!shortlistedCandidates[candidate.user_id]}
                                            canSendMessage={canSendMessage()}
                                            canUseCall={canUseCall()}
                                            canUseWhatsApp={canUseWhatsApp()}
                                            canUseShare={canUseShare()}
                                            canUseShortlist={canUseShortlist()}
                                            messageLimitInfo={getMessageLimitInfo()}
                                            callLimitInfo={getCallLimitInfo()}
                                            whatsAppLimitInfo={getWhatsAppLimitInfo()}
                                            shareLimitInfo={getShareLimitInfo()}
                                            shortlistLimitInfo={getShortlistLimitInfo()}
                                            // ADD THIS LINE:
                                            isInFreeTrial={isInFreeTrial()}
                                            hasPostedJob={hasPostedJob}
                                            unlockedIds={unlockedIds}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        )}
                                {loadingMore && (
                                    <div className="text-center mt-3">
                                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                                {!loadingMore && (visibleCount < filteredCandidates.length || hasMore) && (
                                    <div className="text-center mt-4 mb-3">
                                        <button
                                            className="load-more-btn"
                                            onClick={handleLoadMore}
                                        >
                                            Load More
                                        </button>
                                    </div>
                                )}
                    </Col>
                </Row>

            </Container>

            <ReportCandidate
                candidate={selectedCandidateForReport}
                show={showReportModal}
                onHide={() => setShowReportModal(false)}
            />
            <SendAlertScrollPrompt
                pageKey="employer-candidates"
                pageLabel="Employer Candidates Page"
                jobPosition={categoryFilter === 'company-worker' ? 'Worker' : 'Candidate'}
                user={user}
                navigate={navigate}
            />
            <Footer />
        </>
    );
}

// Updated CandidateCard component with proper free plan handling
function CandidateCard({
    candidate,
    planName,
    userPlanStartDate,
    userPlanEndDate,
    onViewClick,
    onMessageClick,
    onReportClick,
    onShareClick,
    onCallClick,
    onWhatsAppClick,
    onShortlistClick,
    isShortlisted,
    canSendMessage,
    canUseCall,
    canUseWhatsApp,
    canUseShare,
    canUseShortlist,
    messageLimitInfo,
    callLimitInfo,
    whatsAppLimitInfo,
    shareLimitInfo,
    shortlistLimitInfo,
    isInFreeTrial,
    hasPostedJob,
    unlockedIds = []
}) {
    const formatDate = (dateString) => {
        if (!dateString) return 'Not specified';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Check if this candidate's contact has been unlocked
    const isUnlocked = unlockedIds.includes(candidate.user_id);

    const isSubscriptionActive = (() => {
        if (isInFreeTrial) return true;
        if (!planName) return false;
        const normalizedPlan = String(planName).toLowerCase();
        if (normalizedPlan === 'free') return false;
        if (userPlanStartDate && userPlanEndDate) {
            const start = new Date(userPlanStartDate);
            const end = new Date(userPlanEndDate);
            if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
                const now = new Date();
                return now >= start && now <= end;
            }
        }
        return true;
    })();

    // Helper function to get languages - with default value
    const getLanguages = () => {
        if (!candidate.language || candidate.language.length === 0) {
            return 'English, Arabic'; // Default value
        }

        // Get language names from the array of objects
        const languages = candidate.language.map(lang => lang.language);

        // If there are 2 or more languages, show the first two
        if (languages.length >= 2) {
            return `${languages[0]}, ${languages[1]}`;
        }

        // If only 1 language exists, just show it
        return languages[0];
    };

    // Helper function to get main language (for backward compatibility)
    const getMainLanguage = () => {
        if (!candidate.language || candidate.language.length === 0) return 'English, Arabic';
        return `${candidate.language[0].language}`;
    };

    // Helper function to get accommodation preference - with default value
    const getAccommodationPreference = () => {
        if (!candidate.accommodation_preference || candidate.accommodation_preference === 'Not specified') {
            return 'Live in/Live Out'; // Default value
        }
        return candidate.accommodation_preference;
    };

    // Helper function to get visa status - with default value
    const getVisaStatus = () => {
        if (!candidate.visa_type || candidate.visa_type === 'Not specified') {
            return 'Looking for visa'; // Default value
        }
        return candidate.visa_type;
    };

    // Helper function to get available from date - with default value
    const getAvailableFrom = () => {
        const startDate = candidate.preferred_start_date;

        // If it's "Immediate" or similar text, display as-is
        if (!startDate || startDate.toLowerCase().includes('immediate')) {
            return 'Immediate';
        }

        // Try to parse as date
        try {
            const date = new Date(startDate);
            // Check if it's a valid date
            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            } else {
                // If not a valid date, return the original string
                return startDate;
            }
        } catch (e) {
            // If parsing fails, return the original string
            return startDate || 'Immediate';
        }
    };

    const getMainSkills = () => {
        if (!candidate.main_skills || candidate.main_skills.length === 0) return 'Not specified';
        const firstSkill = candidate.main_skills[0];
        if (firstSkill.includes('["')) {
            try {
                const parsed = JSON.parse(firstSkill.replace(/\\/g, ''));
                if (Array.isArray(parsed)) {
                    return parsed.join(', ');
                }
                return parsed;
            } catch (e) {
                return firstSkill;
            }
        }
        return firstSkill;
    };

    const handleShortlistClick = () => {
        if (!canUseShortlist) {
            Swal.fire({
                icon: 'warning',
                title: 'Upgrade Required',
                text: 'To contact this applicant, please upgrade your plan. A valid subscription is required.',
            });
            return;
        }
        onShortlistClick();
    };


    const handleCallClickWrapper = () => {
        // First check if user has posted job
        if (!hasPostedJob) {
            console.log('CandidateCard: User has not posted job, showing post job popup');
            Swal.fire({
                icon: 'warning',
                title: '',
                html: `
        <div style="text-align: center;">
            <p style="font-weight: bold; margin-bottom: 5px;">To view this candidate's profile,</p>
            <p style="font-weight: bold;">please post your job here first.</p>
            <div class="mt-3">
             <button id="close-call-popup-card" class="btn btn-outline-secondary btn-sm" style="border-radius: 5px; height:32px;">
                    Cancel
                </button>
                <button 
                    id="post-job-call-card" style="border-radius: 5px; height:32px; background-color: #28a745; border: none; color: #fff; font-weight: bold;"
                    class="btn btn-success btn-sm me-2">
                    Post a Job
                </button>
               
            </div>
        </div>
    `,
                showConfirmButton: false,
                showCloseButton: true,
                didOpen: () => {
                    document.getElementById('post-job-call-card').onclick = () => {
                        Swal.close();
                        setTimeout(() => window.location.href = '/basicinfo', 300);
                    };
                    document.getElementById('close-call-popup-card').onclick = () => Swal.close();
                }
            });
            return;
        }
        onCallClick(candidate);
    };

    const handleWhatsAppClickWrapper = () => {
        // First check if user has posted job
        if (!hasPostedJob) {
            console.log('CandidateCard: User has not posted job, showing post job popup for WhatsApp');
            Swal.fire({
                icon: 'warning',
                title: '',
                html: `
        <div style="text-align: center;">
            <p style="font-weight: bold; margin-bottom: 5px;">To view this candidate's profile,</p>
            <p style="font-weight: bold;">please post your job here first.</p>
            <div class="mt-3">
            <button id="close-call-popup-card" class="btn btn-outline-secondary btn-sm" style="border-radius: 5px; height:32px;">
                    Cancel
                </button>
                <button 
                    id="post-job-call-card" style="border-radius: 5px; height:32px; background-color: #28a745; border: none; color: #fff; font-weight: bold;"
                    class="btn btn-success btn-sm me-2">
                    Post a Job
                </button>
                
            </div>
        </div>
    `,
                showConfirmButton: false,
                showCloseButton: true,
                didOpen: () => {
                    document.getElementById('post-job-call-card').onclick = () => {
                        Swal.close();
                        setTimeout(() => window.location.href = '/basicinfo', 300);
                    };
                    document.getElementById('close-call-popup-card').onclick = () => Swal.close();
                }
            });
            return;
        }
        onWhatsAppClick(candidate);
    };
    const handleMessageClickWrapper = () => {
        onMessageClick(candidate);
    };

    const getCandidateDisplayName = () => {
        const fullNameFromParts = [candidate.first_name, candidate.last_name]
            .filter(Boolean)
            .join(' ')
            .trim();
        const rawName = String(candidate.full_name || candidate.name || fullNameFromParts || '').split('@')[0].trim();
        if (!rawName) return 'Candidate';
        return rawName.charAt(0).toUpperCase() + rawName.slice(1);
    };

    const handleShareClickWrapper = () => {
        if (!canUseShare) {
            Swal.fire({
                icon: 'warning',
                title: 'Feature Not Available',
                html: `
        <div style="text-align: left;">
          <p>${shareLimitInfo.message}</p>
          <div class="mt-3">
            <button 
              id="upgrade-gold-share-card"  style="border-radius: 5px; height:32px;"
              class="btn btn-primary btn-sm me-2">
              Upgrade to Gold
            </button>
            <button id="close-share-popup-card" class="btn btn-outline-secondary btn-sm">
              Close
            </button>
          </div>
        </div>
      `,
                showConfirmButton: false,
                showCloseButton: true,
                didOpen: () => {
                    document.getElementById('upgrade-gold-share-card').onclick = () => {
                        Swal.close();
                        setTimeout(() => window.location.href = '/subscriptionplans', 300);
                    };
                    document.getElementById('close-share-popup-card').onclick = () => Swal.close();
                }
            });
            return;
        }
        onShareClick(candidate);
    };


    return (
        <Card className="h-100 shadow-sm rounded card-body-alt-candidate nurse-candidate employee-candidate" >
            <Card.Body className="d-flex flex-column justify-content-between">
                <CandidateCardHeading candidate={candidate} />
                <div className="d-flex">
                    <div className="me-3 text-center" style={{ marginTop: '15px' }}>
                        <div className="d-flex justify-content-center gap-1 mt-2">
                            {Number(candidate.purchased_badge) === 1 && (
                                <div className="custom-label-alt verified-label" style={{ width: "80%" }}>
                                    <span className="verified-label-icon">&#10003;</span>
                                    <span>Verified</span>
                                </div>
                            )}

                            {candidate.verification_status?.toLowerCase() !== "verified" &&
                                candidate.created_at &&
                                moment().diff(moment(candidate.created_at), "days") <= 7 && (
                                    <div className="custom-label-alt" style={{ width: "50%" }}>
                                        New
                                    </div>
                                )}
                        </div>

                        <div className="position-relative d-flex justify-content-center mt-2 profile-img-container">
                            {hasVisibleOfferBadge(candidate) && (
                                    <div className="allcandidates-offer-badge">{getVisibleOfferBadgeText(candidate)}</div>
                                )}

                            {candidate.profile_photo ? (
                                <Image
                                    src={candidate.profile_photo}
                                    loading="lazy"
                                    roundedCircle
                                    className="border allcandidate-profile-photo"
                                    alt={`${candidate.first_name || 'Candidate'} profile`}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                />
                            ) : (
                                <div
                                    className="border allcandidate-profile-photo d-flex align-items-center justify-content-center bg-light rounded-circle overflow-hidden"
                                    style={{ width: '100px', height: '100px' }}
                                >
                                    <Image
                                        src={defaultProfileImage}
                                        roundedCircle
                                        className="w-100 h-100"
                                        alt="Default profile"
                                        style={{ objectFit: 'cover' }}
                                    />
                                </div>
                            )}
                        </div>

                        <div className="very-active-label" style={{ color: hasHighlightedSourceLabel(candidate) ? 'green' : '#111', fontWeight: hasHighlightedSourceLabel(candidate) ? '500' : 'normal' }}>
                            {getVisibleSourceLabel(candidate)}
                        </div>
                    </div>

                    <div className="flex-grow-1 allcandidate-card-right-alt nurse-candidate-content employee-candidate-content">
                        {Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("nurse")) ? (
                            <>
                                <h6 className="fw-bold nurse-candidate-name employee-candidate-name">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 custom-list candidate-nurse-details nurse-candidate-list allcandidatescustom-list employercandidate-nurse-details employercandidate-details">
                                    <li>
                                        <strong>Name - </strong>
                                        {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("doctor")) ? (
                            <>
                                <h6 className="fw-bold nurse-candidate-name employee-candidate-name">
                                    <span style={{ fontWeight: 500 }}>
                                        Dr.{candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}years- </span><span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 custom-list candidate-doctor-details nurse-candidate-list allcandidatescustom-list employercandidate-doctor-details employercandidate-details">
                                    <li>
                                        <strong>Name - </strong>
                                        Dr. {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("driver")) ? (
                            <>
                                <h6 className="fw-bold nurse-candidate-name employee-candidate-name">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 custom-list nurse-candidate-list allcandidatescustom-list employer-candidate-list employercandidate-details">
                                    <li>
                                        <strong>Name - </strong>
                                        {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>License - </strong>{' '}
                                        <span>
                                            {candidate.driving_license_country
                                                ? (() => {
                                                    try {
                                                        // Parse if it's a JSON string
                                                        let licenseData = candidate.driving_license_country;

                                                        // Check if it's a string that needs parsing
                                                        if (typeof licenseData === 'string' &&
                                                            (licenseData.startsWith('[') || licenseData.startsWith('"'))) {
                                                            licenseData = JSON.parse(licenseData);
                                                        }

                                                        // Handle array of licenses
                                                        if (Array.isArray(licenseData)) {
                                                            // Process each license to extract only country name
                                                            const processedLicenses = licenseData.map(license => {
                                                                if (typeof license === 'string') {
                                                                    // Extract country name before dash, or use the whole string if no dash
                                                                    const parts = license.split('–').map(part => part.trim());
                                                                    return parts[0]; // Return only the country name
                                                                }
                                                                return license;
                                                            });
                                                            return processedLicenses.join(', ');
                                                        }

                                                        // Handle single license (string)
                                                        if (typeof licenseData === 'string') {
                                                            // Extract country name before dash
                                                            const parts = licenseData.split('–').map(part => part.trim());
                                                            return parts[0]; // Return only the country name
                                                        }

                                                        return licenseData || 'Not specified';
                                                    } catch (e) {
                                                        // If parsing fails, treat as regular string and extract country
                                                        const licenseStr = String(candidate.driving_license_country);
                                                        const parts = licenseStr.split('–').map(part => part.trim());
                                                        return parts[0]; // Return only the country name
                                                    }
                                                })()
                                                : 'Not specified'
                                            }
                                        </span>
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : (
                            <>
                                <h6 className="fw-bold nurse-candidate-name employee-candidate-name">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 custom-list nurse-candidate-list domesticcustom-list domesticcandidate-normal-details allcandidatescustom-list employercandidate-details">
                                    <li>
                                        <strong>Name - </strong>
                                        {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            // Check if both USD and local amounts are 0 or not provided
                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            // Extract currency code from expected_monthly_salary_currency
                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                // Get the first part before space or bracket (e.g., "INR" from "INR (India")
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                // Fallback: Map nationality to currency code
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        )}
                    </div>
                </div>

                                {/* Buttons */}
                <Row className="mt-1">
                    <Col xs={3} className="px-1">
                        <Button
                            variant="light"
                            className="w-100 small-btn action-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                const user = JSON.parse(localStorage.getItem("user")) || {};
                                if (!user || (user.role !== 'agency' && user.role !== 'agency_admin')) {
                                    import('sweetalert2').then(Swal => {
                                        Swal.default.fire('Access Denied', 'Video Call feature is only available to Agencies.', 'error');
                                    });
                                } else if (user.plan_name === 'Free' || user.plan_name === 'Free Plan (Contact)') {
                                    import('sweetalert2').then(Swal => {
                                        Swal.default.fire({
                                            icon: 'error',
                                            title: 'Upgrade Required',
                                            text: 'Video Call feature is available for exclusive plans. Please upgrade.',
                                            confirmButtonText: 'Upgrade Now'
                                        }).then((result) => {
                                            if (result.isConfirmed) window.location.href = '/subscription';
                                        });
                                    });
                                } else {
                                    window.dispatchEvent(new CustomEvent('initiate-video-call', { 
                                        detail: { 
                                            candidateId: candidate?.user_id || candidate?.id, 
                                            candidateName: candidate?.first_name 
                                        } 
                                    }));
                                }
                            }}
                        >
                            <FaVideo className="text-primary" />
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="secondary" style={{ backgroundColor: '#7177a6' }}
                            className={`w-100 small-btn action-button gap-2 ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleCallClickWrapper}
                        >
                            <FaPhoneAlt /> Call
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button variant="allcandidates-veiwbutton" className="w-100 small-btn action-button gap-2 allcandidates-veiwbutton" onClick={onViewClick}>
                            <FaEye /> View
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="success"
                            className={`w-100 small-btn action-button ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleWhatsAppClickWrapper}
                        >
                            <i className="bi bi-whatsapp" />
                        </Button>
                    </Col>
                </Row>

                <Row className="mt-1 text-center text-muted small fw-medium border-top pt-2 last-buttons-row">
                    <Col
                        className={`cursor-pointer no-underline ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                        onClick={handleShortlistClick}
                    >
                        {isShortlisted ? (
                            <FaHeart className="text-danger me-1" />
                        ) : (
                            <FaRegHeart className="me-1" />
                        )}
                        Like
                    </Col>
                    <Col
                        className={`cursor-pointer no-underline ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                        onClick={handleShareClickWrapper}
                    >
                        <i className="bi bi-share me-1"></i> Share
                    </Col>
                    <Col className="cursor-pointer no-underline" onClick={handleMessageClickWrapper}>
                        <i className="bi bi-chat-dots me-1"></i> Message
                    </Col>
                    <Col className="cursor-pointer no-underline" onClick={onReportClick}>
                        <i className="bi bi-flag me-1"></i> Report
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default Candidates;
